export const fr_strings = {
  'err.pattern.^0[1-9]\\d{6,14}$': "Le numéro doit commencer par 0, suivi d'un chiffre entre 1 et 9, puis de 6 à 14 chiffres.",
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ\' .\-]*$': 'Le champ « {fieldName} » doit contenir uniquement des lettres, accents, espaces, apostrophes, points et tirets.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\\s\\-\\.\'\(\)]*$': 'Le champ « {fieldName} » doit contenir uniquement des lettres, chiffres, accents, espaces, tirets, points, apostrophes et parenthèses.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-\\s]+$': 'Le champ « {fieldName} » doit contenir uniquement des lettres, chiffres, accents, espaces, apostrophes, points, parenthèses et tirets.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\'.,\(\)\- ]*$': 'Le champ « {fieldName} » doit contenir uniquement des lettres, chiffres, accents, espaces, apostrophes, virgules, points, parenthèses et tirets.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]*$': 'Le champ « {fieldName} » doit contenir uniquement des lettres, chiffres, accents, espaces, apostrophes, points, parenthèses et tirets.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]+$': 'Le champ « {fieldName} » doit contenir uniquement des lettres, chiffres, accents, espaces, apostrophes, points, parenthèses et tirets.',
  'smartTable.paymentType': 'Type de paiement',
  'tooltip.allNotes': 'Voir toutes les notes',
  'tooltip.openDuplicate': 'Ouvrir le dernier paiement dupliqué',
  'payment.openDuplicate': 'Ouvrir le duplicata',
  'smartTable.indicatifTelephoneNumber': 'Indicatif téléphonique',
  'smartTable.phone': 'Téléphone',
  'ask.noTimeSlotBooked': 'Vous avez une demande sans rendez-vous. Souhaitez-vous en réserver un maintenant ? Cette action est requise pour finaliser votre demande.',
  'place.warn_closure': 'Tous les rendez-vous prévus les jours désormais fermés pour ce lieu seront annulés, et les utilisateurs concernés en seront informés. Souhaitez-vous continuer ?',
  'calendar.mode.open': 'Ouvert par défaut',
  'calendar.mode.closed': 'Fermé par défaut',
  'calendar.regular_opening_days': 'Jours d\'ouverture réguliers',
  'calendar.exceptional_opening_days': 'Jours d\'ouverture exceptionnels',
  'calendar.time_ranges': 'Plages horaires',
  'calendar.from': 'De',
  'calendar.to': 'À',
  'calendar.remove_range': 'Supprimer',
  'err.pattern.^\\+[1-9][0-9]{7,14}$': 'Le champ "{fieldName}" doit commencer par un "+" suivi de 8 à 15 chiffres.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .()\\-]*$': 'Le champ « {fieldName} » doit contenir uniquement des lettres, chiffres, accents, espaces, apostrophes, points, parenthèses et tirets.',
  'calendar.add_range': 'Ajouter une plage',
  'calendar.confirmReset': 'Souhaitez-vous réinitialiser tous les réglages actuels ?',
  'err.pattern.password': 'Le mot de passe doit contenir au moins deux des éléments suivants : une lettre minuscule, une lettre majuscule, un chiffre ou un caractère spécial.',
  'form.perm1.DYN.': 'Créer une application',
  'global.pay': 'Payer',
  'smartTable.timeslot': 'Créneau horaire',
  'smartTable.requestReason': 'Motif de la demande',
  'smartTable.passportType': 'Type de passeport',
  'refusalReason.desc.DYN.': '<p>Veuillez fournir une brève description du motif du refus.</p>',
  'timezone.notice': 'Les rendez-vous sont planifiés selon le fuseau horaire du lieu de rendez-vous.',
  'timeslot.noBooking': 'Aucune réservation de créneau n\'a été effectuée.',
  'timeslot.tooCloseToChange': 'Vous ne pouvez plus modifier ce rendez-vous car il est prévu dans moins de {hours}h.',
  'session.inactive.title': 'Session inactive',
  'session.inactive': 'Votre session a expiré pour cause d\'inactivité',
  'reactivateSession': 'Réactiver la session',
  'global.changeTimeSlot': 'Changer le créneau',
  'supervisorAccountName': 'Nom du compte superviseur',
  'err.supervisorAccountName.required': 'Le nom du compte superviseur est requis',
  'scan.supervisor.desc': 'Veuillez entrer le nom de compte du superviseur pour procéder à l\'action suivante :</br><b>{actionText}</b>',
  'scan.supervisor.noFingerprint': 'Aucune donnée d\'empreinte digitale trouvée pour ce nom de compte superviseur',
  'outUsage.AB': 'Cette demande est <b>hors de sa période de validité</b>. Veuillez diriger le demandeur vers le kiosque ou l\'aider à soumettre à nouveau sa demande.',
  'outUsage.C': 'Cette demande est <b>hors de sa période de validité</b>. Veuillez fermer cette demande, puis créer une nouvelle entrée pour le demandeur et procéder au refus.',
  'err.payment.notAvailable': 'Cette demande n\'est pas disponible.',
  'form.PlaceOfBirth': 'Lieu de naissance',
  'borderPass': 'Laissez-passer frontalier',
  'urgent_pass': 'Passeport urgent',
  'feedback': 'Retour',
  'err.mustBeDifferentThan.errorValue': 'Le champ "{fieldName}" doit être différent de {errorValue}.',
  'DYN.PASSPORT_WRONG': 'Passeport incorrect',
  'err.max.errorValue': 'Le champ "{fieldName}" doit être inférieur à {errorValue}.',
  'err.max': 'Le champ "{fieldName}" doit être inférieur à la valeur maximale autorisée.',
  'err.min.errorValue': 'Le champ "{fieldName}" doit être supérieur à {errorValue}.',
  'err.min': 'Le champ "{fieldName}" doit être supérieur à la valeur minimale autorisée.',
  'updateField.desc': 'Veuillez fournir les informations mises à jour pour le champ suivant : <b>{field}</b>',
  'marital.status.engaged': 'Engagé',
  'payment_status.desc.DYN.passport_booked.toPay': 'La demande de document a été réservée et doit encore être payée.',
  'payment_status.desc.DYN.passport_booked': 'La demande de document a été réservée et payée.',
  'place.notExist': 'Le lieu n\'existe pas',
  'ApplicationForm': 'Formulaire de demande',
  'BirthCertificate': 'Certificat de naissance',
  'ParentalAuthorization': 'Autorisation parentale',
  'printSettings.selected': 'Vous modifiez les paramètres d\'impression pour le document : <b>{documentName}</b>',
  'print.settings.success': 'Les paramètres d\'impression ont été mis à jour avec succès pour le document : <b>{documentName}</b>',
  'error.noHasFace': 'Aucun visage n’a été détecté sur la photo. Veuillez reprendre la photo.',
  'name.warn': 'Le prénom ou/et le nom est vide ou contient moins de 2 caractères.',
  'kiosk.redirect': 'Votre nationalité ne permet pas de continuer en mode kiosque. Veuillez vous connecter avec un compte pour poursuivre. Vous allez être redirigé vers l\'écran de connexion.',
  'err.OtherPurpose.required': 'Le champ "Autre motif" est requis',
  'print.qr.verification': 'Vérification',
  'print.qr.application': 'Demande',
  'print.terms': 'Les conditions générales s\'appliquent.',
  'movements.empty': 'Aucun mouvement n\'a été enregistré pour le moment.',
  'movement.history': 'Historique entrée/sortie',
  'payment.notes': 'Notes',
  'payment.noNotes': 'Aucune note pour le moment',
  'extension.alreadyExists.warning': 'Une extension existe déjà pour cette demande. Êtes-vous sûr de vouloir en créer une nouvelle ?',
  'payment.addNote.placeholder': 'Ajouter une note…',
  'global.seeMore': 'Voir plus',
  'global.seeLess': 'Voir moins',
  'err.hostPhone.pattern': 'Le numéro de téléphone doit commencer par + (indicatif du pays) ou 0 et contenir entre 7 et 15 chiffres.',
  'reprintSticker': 'Réimpression du sticker',
  'err.daysGranted.max': 'Le nombre de jours ne peut pas dépasser le nombre de jours demandés.',
  'err.daysGranted.min': 'Количество дней должно быть не менее 1.',
  'err.daysGranted.required': 'Le nombre de jours est requis.',
  'approval.daysGranted.error': 'Veuillez saisir un nombre de jours valide.',
  'err.password.pattern': 'Le mot de passe doit contenir au moins deux des éléments suivants : une lettre minuscule, une lettre majuscule, un chiffre ou un caractère spécial.',
  'err.documentNumber.pattern': 'Le numéro de document ne doit contenir que des lettres, des chiffres, des espaces et des tirets.',
  'supervision.login.error': 'Échec de la vérification du superviseur.',
  'ask.borderpass': 'Est-ce vraiment un laissez-passer frontalier ?',
  'err.ExistingValidEntryReference.required': 'La référence d\'entrée valide existante est requise',
  'BirthCountry': 'Pays de naissance',
  'old': 'Ancien mot de passe',
  'firstName': 'Prénom',
  'email': 'Email',
  'paymentMethod': 'Méthode de paiement',
  'client.extended.softLockedOutLogin30Minutes': 'Vous avez été verrouillé pendant 30 minutes. Veuillez réessayer plus tard.',
  'client.extended.tooManyRequests': 'Trop de requêtes. Veuillez réessayer plus tard.',
  'password': 'Mot de passe',
  'password2': 'Confirmer le mot de passe',
  'PreviousConvictions': 'Convictions',
  'Address': 'Adresse',
  'global.continue': 'Continuer',
  'err.err': 'Erreur',
  'err.maxDateMilliFrom.errorValue': 'Le champ "{fieldName} ne doit pas dépasser la limite du "{errorValue}", définie du champ "{control}".',
  'err.maxDateMilliTo.errorValue': 'Le champ "{fieldName}" doit précéder la limite fixée {errorValue}, définie du champ "{control}"',
  'err.mustBeEqualOrAfter.errorValue': 'Le champ "{fieldName}" doit être égale ou postérieur au champ "{errorValue}".',
  'err.mustBeEqualOrBefore.errorValue': 'Le champ "{fieldName}" doit être égale ou antérieure au champ "{errorValue}".',
  'err.maxDateMilliFromToday.errorValue': 'Le champ "{fieldName}" ne doit pas dépasser le {errorValue}',
  'err.minDateMilliFromNow': 'Le champ "{fieldName}" doit être une date postérieure à la date minimum autorisée.',
  'err.maxDateMilliFromNow': 'Le champ "{fieldName}" doit contenir une date antérieure à la date maximale autorisée.',
  'err.mustMatch': 'Le champ {fieldName} doit être identique au champ correspondant.',
  'err.requireOneOf.errorValue': '{errorValue} doit être fourni',
  'err.requireOneOf.field': 'Le champ \'{name}\'',
  'err.requireOneOf.separator': ' ou ',
  'err.pattern.^[0-9]{6,14}$': 'Le champ "{fieldName}" doit contenir entre 6 et 14 chiffres.',
  'err.patten.^[0-9A-Za-z\\-\\s]{3,15}$': 'Le champ "{fieldName}" doit contenir entre 3 et 15 caractères alphanumériques, tirets ou espaces.',
  'err.pattern.^[+]?[0-9\\s\\-\\(\\)]{7,20}$': 'Le champ "{fieldName}" doit contenir entre 7 à 20 caractères : chiffres, espace, tirets, parenthèses',
  'err.pattern.^[0-9A-Za-z]{5,20}$': 'Le champ "{fieldName}" doit contenir entre 5 à 20 caractères alphanumériques',
  'err.pattern.^[0-9]{10}$': 'Le champ "{fieldName}" doit contenir exactement 10 chiffres.',
  'err.pattern.^[0-9A-Za-z]{5,20}': 'Le champ "{fieldName}" doit contenir entre 5 et 20 caractères alphanumériques.',
  'err.pattern.^[0-9]{8,20}$': 'Le champ "{fieldName}" doit contenir 8 à 20 chiffres.',
  'err.pattern.^[A-Za-z0-9]{5,15}$': 'Le champ "{fieldName}" doit contenir 5 à 15 caractères alphanumériques.',
  'err.pattern.^((?:data:image/(jp2|jpeg);base64,)*([A-Za-z0-9+/==]+))': 'Le champ "{fieldName}" doit être une image JPEG ou JP2 encodée en base64 avec un format valide.',
  'err.pattern.^[a-z]$': 'Le champ "{fieldName}" doit contenir une seule lettre minuscule.',
  "err.pattern.^[A-Z' -]*$": 'Le champ "{fieldName}" ne peut contenir que des lettres majuscules, des apostrophes, des espaces et des tirets.',
  'err.pattern.^[0-9-]{6,15}$': 'Le champ "{fieldName}" doit contenir entre 6 et 15 caractères (chiffres et tirets uniquement).',
  'err.pattern.^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$': 'Le champ "{fieldName}" doit être une adresse email valide.',
  'err.pattern.^(?:data:image/(jpeg|png|webp);base64,|data:application/pdf;base64,)*([A-Za-z0-9+/==]+)$': 'Le champ "{fieldName}" (JPEG, PNG, WebP) ou un PDF encodé en base64 avec un format valide',
  'err.pattern.^[A-Z]{3}$': 'Le champ "{fieldName}" doit contenir exactement trois lettres majuscules',
  'err.pattern.^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,9}$': 'Le champ "{fieldName}" doit contenir un numéro de téléphone valide, avec ou sans indicatif, et peut inclure des espaces, des tirets ou des points.',
  'err.pattern.^(?:\\+[1-9]\\d{6,14}|0\\d{6,14})$': 'Le champ "{fieldName}" doit contenir un numéro de téléphone international ou national valide (ex. : +1234567890 ou 0123456789).',
  'err.pattern.^(?:\\+[1-9]\\d{8,9}|0\\d{8,9})$': 'Le champ "{fieldName}" doit contenir un numéro de téléphone valide au format international (+1234567890) ou national (0123456789), 9-10 chiffres après l\'indicatif pays.',
  'err.pattern.^[A-Za-z\\s\\-]+$': 'Le champ "{fieldName}" ne peut contenir que des lettres, des espaces et des tirets.',
  "err.pattern.^[a-zA-Z' -]*$": 'Le champ "{fieldName}" ne peut contenir que des lettres, des apostrophes, des espaces et des tirets.',
  'err.pattern.^[A-Za-z0-9\\s\\-]+$': 'Le champ "{fieldName}" ne peut contenir que des lettres, des chiffres, des espaces et des tirets.',
  'err.pattern.^[0-9]*$': 'Le champ "{fieldName}" doit contenir uniquement des chiffres.',
  'err.pattern.^[0-9]{4}-[0-9]{2}-[0-9]{2}$': 'Le champ "{fieldName}" doit être une date valide.',
  'err.pattern.^(?:\\+[1-9]\\d{0,3}|0)$': 'Le champ "{fieldName}" doit commencer par + suivi de 1 à 4 chiffres.',
  'err.pattern.^[A-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ][a-zA-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ\\-. ]*$': 'Le champ "{fieldName}" doit commencer par une lettre majuscule et peut contenir des lettres minuscules, des accents, des espaces, des apostrophes, des tirets ou des points.',
  'err.pattern.^[A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒàáâãäåçèéêëìíîïòóôõöùúûüæœ\\-. ]*$': 'Le champ "{fieldName}" doit contenir uniquement des lettres (avec ou sans accents), des espaces, des apostrophes, des tirets ou des points.',
  'err.pattern.^[A-Z0-9]+$': 'Le champ "{fieldName}" doit contenir uniquement des lettres majuscules et des chiffres.',
  'err.pattern.^(?:\\+[1-9]\\d{0,3})$': 'Le champ "{fieldName}" doit commencer par un "+" suivi de 1 à 4 chiffres (le premier chiffre ne peut pas être 0).',
  'err.required': 'Le champ "{fieldName}" est requis.',
  'err.minDateMilliFromNow.errorValue': 'Le champ "{fieldName}" doit être une date postérieure au {errorValue}.',
  'err.maxDateMilliFromNow.errorValue': 'Le champ "{fieldName}" doit être une date antérieure au {errorValue}.',
  'err.maxlength.errorValue': 'Le champ "{fieldName}" doit contenir au maximum {errorValue} caractères.',
  'err.minlength.errorValue': 'Le champ "{fieldName}" doit contenir au minimum {errorValue} caractères.',
  'err.maxlength': 'Le champ "{fieldName}" est trop long.',
  'err.minlength': 'Le champ "{fieldName}" est trop court.',
  'err.pattern': 'Le champ "{fieldName}" contient un format invalide.',
  'err.email': 'Le champ "{fieldName}" doit être une adresse email valide.',
  'Nationality': 'Nationalité',
  'err.nationality.required': 'La nationalité est requise.',
  'form.lang.EN': 'English',
  'form.lang.FR': 'Français',
  'form.lang.AR': 'عربي',
  'form.lang.PT': 'Português',
  'form.lang.DE': 'Deutsch',
  'form.lang.RU': 'Русский',
  'form.lang.CN': '中文',
  'successPayment.booking.title': 'Réservation confirmée !',
  'global.bookTimeSlot': 'Réserver un créneau horaire',
  'client.extended.maxMonthlyPaymentsReached': 'Vous avez atteint le nombre maximum de paiements mensuels. Veuillez contacter le support.',
  'calendar.weekday.sunday': 'Dim',
  'calendar.weekday.monday': 'Lun',
  'calendar.weekday.tuesday': 'Mar',
  'calendar.weekday.wednesday': 'Mer',
  'calendar.weekday.thursday': 'Jeu',
  'calendar.weekday.friday': 'Ven',
  'calendar.weekday.saturday': 'Sam',
  'calendar.month.january': 'Janvier',
  'calendar.month.february': 'Février',
  'calendar.month.march': 'Mars',
  'calendar.month.april': 'Avril',
  'calendar.month.may': 'Mai',
  'calendar.month.june': 'Juin',
  'calendar.month.july': 'Juillet',
  'calendar.month.august': 'Août',
  'calendar.month.september': 'Septembre',
  'calendar.month.october': 'Octobre',
  'calendar.month.november': 'Novembre',
  'calendar.month.december': 'Décembre',
  'calendar.timeline.no_slots': 'Aucun créneau disponible pour cette journée',
  'calendar.timeline.available': 'Libre',
  'calendar.timeline.spots_available': 'places disponibles',
  'calendar.timeline.fully_booked': 'Complet',
  'calendar.confirm_booking_title': 'Confirmer la réservation',
  'calendar.confirm_booking_message': 'Veuillez confirmer que vous souhaitez réserver ce créneau horaire.',
  'calendar.booking_in_progress': 'Réservation en cours...',
  'calendar.please_wait': 'Veuillez patienter pendant que nous traitons votre réservation.',
  'calendar.booking_error_title': 'Erreur de réservation',
  'calendar.booking_success_title': 'Réservation confirmée !',
  'calendar.booking_success_message': 'Votre créneau horaire a été réservé avec succès.',
  'calendar.proceed_to_payment': 'Procéder au paiement',
  'calendar.auto_proceed_message': 'Redirection automatique dans...',
  'calendar.date': 'Date',
  'calendar.time': 'Heure',
  'calendar.place': 'Lieu',
  'calendar.loading_month': 'Chargement des disponibilités...',
  'extension.error.maxDays': 'Vous ne pouvez pas demander plus de 30 jours par extension.',
  'DYN.processed.NOTICES_ACCEPTED': 'Notice(s) validées',
  'notices_validated': 'Notices validées',
  'err.daysUntilReport.pattern': 'Le nombre de jours jusqu\'à la prochaine visite doit avoir un format correct',
  'err.reportInterval.pattern': 'L\'intervalle de rapport doit être un nombre supérieur ou égal à 0',
  'err.CompanionsSize.min': 'Le nombre de compagnons doit être au moins de 1',
  'err.CompanionsSize.max': 'Le nombre de compagnons est trop long',
  'global.error': 'Une erreur est survenue. Veuillez réessayer. Si le problème persiste, veuillez contacter le support.',
  'err.DurationOfStay.required': 'La durée de séjour est requise',
  'err.DurationOfStay.min': 'La durée de séjour doit être au moins de 1 jour',
  'err.DurationOfStay.max': 'La durée de séjour est trop longue',
  'DurationOfStay': 'Durée de séjour (jours)',
  'tooltip.acceptNotices': 'Valider la notice en cours',
  'notices': 'Notices',
  'ask.notices': 'Voulez-vous valider la notice ?',
  'accept.notices': 'Valider la notice',
  'err.ModeOfTravel.required': 'Le mode de déplacement est requis',
  'err.FlightNumber.required': 'Le numéro de vol est requis',
  'err.ShipNumber.required': 'Le numéro de bateau est requis',
  'err.CarNumber.required': 'Le numéro de voiture est requis',
  'err.BusNumber.required': 'Le numéro de bus est requis',
  'err.TrainNumber.required': 'Le numéro de train est requis',
  'err.FlightNumber.pattern': 'Le numéro de vol doit avoir un format correct',
  'err.ShipNumber.pattern': 'Le numéro de bateau doit avoir un format correct',
  'err.CarNumber.pattern': 'Le numéro de voiture doit avoir un format correct',
  'err.BusNumber.pattern': 'Le numéro de bus doit avoir un format correct',
  'err.TrainNumber.pattern': 'Le numéro de train doit avoir un format correct',
  'ModeOfTravel': 'Mode de déplacement',
  'FlightNumber': 'Numéro de vol',
  'ShipNumber': 'Numéro de bateau',
  'CarNumber': 'Numéro de voiture',
  'BusNumber': 'Numéro de bus',
  'TrainNumber': 'Numéro de train',
  'DYN.flight': 'Par avion',
  'DYN.ship': 'Par bateau',
  'DYN.car': 'Par voiture',
  'DYN.bus': 'Par bus',
  'DYN.train': 'Par train',
  'DYN.foot': 'A pied',
  'expiredSinceTime': 'La demande est expirée depuis <b> {days} jours et {hours} heures </b>.',
  'existingValidEntryReference.desc': 'Cette application contient une <b>référence d\'entrée valide</b>. Cela signifie que le voyageur a déjà payé et été autorisé à entrer. Veuillez vous assurer de vérifier la validité de la référence avant de continuer. Si tout est correct, vous pouvez procéder au check-in.',
  'visa.paidOnArrival': 'Payer la taxe d\'entrée à l\'arrivée',
  'start': 'commencer',
  'warn.payment.offlineApplication.quit': 'Vous êtes sur le point de quitter un processus de demande hors ligne. Êtes-vous sûr de vouloir continuer ?<br><br><b>Toutes les données seront perdues.</b>',
  'total': 'Total',
  'tooltip.printEvents': 'Liste de tous les événements d’impression de cette demande',
  'tooltip.prepareLandingVisa': 'Préparer un visa à l’arrivée',
  'tooltip.consumeOfficer.OUT': 'L’agent qui a enregistré la sortie de la personne.',
  'tooltip.consumeOfficer.IN': 'L’agent qui a effectué l’enregistrement de la personne.',
  'supervision.catC.ordinary.refuse': 'ENTRÉE REFUSÉE',
  'supervision.catC.ordinary.entry': 'ENREGISTREMENT',
  'scanned': 'Scanné',
  'scan.noEntryFound.wrongPassportType': 'Un ou plusieurs statuts "Prêt pour l’enregistrement" ont été trouvés pour cette personne, mais le type de passeport ne correspond pas au document scanné.<br> <b>Veuillez créer une nouvelle entrée pour cette personne.</b>',
  'scan.noExitFound.wrongPassportType': 'Un ou plusieurs statuts "Prêt pour la sortie" ont été trouvés pour cette personne, mais le type de passeport ne correspond pas au document scanné.<br> <b>Veuillez créer une nouvelle sortie pour cette personne.</b>',
  'printEventsCollapse': 'Tous les événements d’impression de cette demande',
  'printEvent.desc': 'Cette demande de visa a été imprimée avec tous ses documents le {date} par l’utilisateur',
  'print.extension': 'Imprimer la prolongation',
  'print.alreadyPrinted': 'Les documents de cette demande ont été imprimés pour la dernière fois le {date} par l’utilisateur {user}. Souhaitez-vous les imprimer à nouveau ?',
  'payment_status.desc.offlineApplication': 'Cette demande est actuellement traitée <b>HORS LIGNE</b>. Poursuivez le processus, qui sera envoyé dans la file de synchronisation une fois terminé.',
  'payment_status.desc.DYN.8.review': 'Cette demande de document est actuellement en attente de révision par un superviseur.',
  'payment_status.DYN.8.review': 'En attente de révision',
  'payment.consume.placeNotAllowed': 'Cette demande ne peut pas être traitée à cet emplacement. Le voyageur doit se rendre dans l’un des emplacements suivants : <br><b>{places}</b>',
  'open.visaReference': 'Ouvrir la demande liée',
  'onlyFinalReview': 'Cette demande est en attente de la révision finale.',
  'no.must_pay': 'Paiement toujours requis',
  'info.testingReaderCard': 'Vérification de la présence d’une carte à puce dans le lecteur...',
  'info.testingReader': 'Vérification de la présence du lecteur...',
  'info.testingBAC': 'Exécution du contrôle d’accès de base (BAC)...',
  'info.searchingPayment': 'Recherche de la demande sur les serveurs...',
  'info.readingPayment': 'Lecture des informations détaillées depuis le serveur...',
  'info.readingMrz': 'Lecture de la MRZ en cours...',
  'info.readingDG': 'Lecture des groupes de données en cours...',
  'info.readingCertificate': 'Lecture du certificat de signature en cours...',
  'info.doingPA': 'Authentification passive en cours...',
  'info.disconnect': 'Déconnexion en cours...',
  'info.convertingImage': 'Conversion de l’image lue depuis le document...',
  'info.connecting': 'Connexion à la puce en cours...',
  'download.logs.tooltip': 'Téléchargez les fichiers de log complets des activités inhabituelles en ligne et hors ligne. Ce fichier sera téléchargé au format JSON et est principalement utilisé à des fins de débogage.',
  'error.updatePassport': 'Une erreur est survenue lors de la mise à jour de la demande. Veuillez réessayer.',
  'download.logs': 'Télécharger les fichiers de log',
  'done.closeApplication': 'La demande a été clôturée avec succès. Souhaitez-vous créer une nouvelle demande en vous basant sur les données de celle-ci ?',
  'documents.load': 'Charger tous les documents',
  'documents.add': 'Ajouter un document manquant',
  'customerName': 'Nom du client',
  'global.changePassword': 'Changer de mot de passe',
  'signIn.forgotPassword': 'Mot de passe oublié',
  'signIn.title': 'Se connecter',
  'global.notAccount': 'Pas encore de compte ?',
  'signUp.title': 'Créer un compte',
  'DYN.selectedPaymentMethod.VISA': 'Vous avez sélectionné de payer avec <b>Visa</b>.',
  'DYN.selectedPaymentMethod.MASTERCARD': 'Vous avez sélectionné de payer avec <b>Mastercard</b>.',
  'DYN.selectedPaymentMethod.AMERICAN_EXPRESS': 'Vous avez sélectionné de payer avec <b>American Express</b>.',
  'DYN.selectedPaymentMethod.DINERS_CLUB': 'Vous avez sélectionné de payer avec <b>Diner\'s Club</b>.',
  'DYN.selectedPaymentMethod.UNION_PAY': 'Vous avez sélectionné de payer avec <b>Union Pay</b>.',
  'DYN.selectedPaymentMethod.ZIMSWITCH': 'Vous avez sélectionné de payer avec <b>Zimswitch</b>.',
  'DYN.selectedPaymentMethod.PAYPAL': 'Vous avez sélectionné de payer avec <b>PayPal</b>.',
  'DYN.selectedPaymentMethod.DISCOVER': 'Vous avez sélectionné de payer avec <b>Discover</b>.',
  'ProvisionnalEntryPort': 'Point d\'enregistrement souhaité',
  'consumeMode.transit': 'Vous êtes actuellement en <b>mode Transit</b>. Les demandes seront automatiquement <b>traitées à l’entrée et à la sortie en même temps</b>. Ce mode est utilisé pour les voyageurs en transit qui n’ont pas besoin de séjourner dans le pays.',
  'ask.isExtension.confirm': 'Confirmez-vous que le paiement a été effectué ? Si oui, veuillez saisir la référence du paiement, le mode de paiement et la devise utilisée.',
  'ask.closeApplication': 'Cette action peut être utilisée lorsqu’un voyageur peut fournir une preuve qu’une opération a été effectuée hors ligne, permettant de considérer cet enregistrement comme résolu et de le supprimer. Veuillez confirmer que vous souhaitez clôturer cette demande. Cette action est définitive et ne peut pas être annulée.',
  'approval.daysGranted.limit': 'Le nombre de jours accordés ne peut pas dépasser les {days} jours demandés.',
  'approval.daysGranted.DYN.': 'Nombre de jours accordés',
  'ExistingValidEntryReference': 'Référence d’entrée valide existante',
  'DYN.form.documentNumber.scanned': 'Numéro de {document}',
  'DYN.document.P': 'Passeport',
  'DYN.document.OTHER': 'Document',
  'DYN.document.IR': 'Titre de séjour',
  'DYN.document.ID': 'Carte d\'identité',
  'DYN.document.D': 'Permis de conduire',
  'tooltip.externalIndexedData': 'Plusieurs passeports ont été trouvés pour cette personne.',
  'visaDocumentsMaxTotalSize': 'La taille totale des documents téléchargés dépasse la taille maximale autorisée de {size} Mo. Veuillez réduire la taille des documents et réessayer.',
  'help': 'Aide',
  'unlimited': 'Illimité',
  'ask.clear.storage': '<b>Cette action effectuera un nettoyage complet des données du site, similaire à la fonctionnalité "Effacer les données du site" de Chrome.</b><br>Cela effacera : localStorage, sessionStorage, IndexedDB, Cache Storage, Service Workers, Cookies et autres stockages du navigateur. Toutes les données encore dans la file d\'attente seront téléchargées dans un fichier JSON avant d\'être effacées.<br><br>Êtes-vous sûr de vouloir continuer ?',
  'clear.storage': 'Effacer le stockage',
  'clear.storage.tooltip': 'Effacez toutes les données stockées localement.',
  'application.placeAllowed': '<b>RESTRICTION DE LIEU :</b> Ce document ne peut être traité qu’aux emplacements suivants : <b>{places}</b>',
  'apply.overstay': 'Appliquer les frais',
  'no_apply.overstay': 'Pas de frais',
  'paymentExtension.overstay': 'Cette demande est actuellement en dépassement de séjour.<br><br><strong>Prix de base de l\'extension :</strong> {basePrice}<br><strong>Pénalité de dépassement :</strong> {penalty}<br><strong>Total avec pénalité :</strong> {totalPrice}<br><br>Vous pouvez choisir si les frais de dépassement doivent être appliqués ou non.',
  'paymentUntil.gracePeriod': 'La demande suivante est actuellement dans la période de grâce, qui se termine le <b>{date}</b>. <br><br> Vous pouvez choisir si des frais de dépassement doivent être appliqués ou non.',
  'transactionReference.alt': 'Référence de la transaction',
  'paymentType.alt': 'Type de paiement',
  'changeGender.ask': 'Le genre sur la demande doit être modifié en Homme ou Femme.',
  'print.askMultiple': 'Souhaitez-vous inclure tous les documents associés dans l’impression ?',
  'application.id': 'ID de la demande',
  'printSticker': 'Imprimer l’autocollant de visa',
  'correctionFields': 'Les champs suivants ont été corrigés :',
  'corrected.desc': 'Cette demande de visa a été corrigée par le demandeur le {date}.',
  'recentlyCorrected': 'Corrigé',
  'visaValidFrom': 'Validité d’entrée à partir de',
  'visaValidUntil': 'Validité d’entrée jusqu’au',
  'online': 'En ligne',
  'offline': 'Hors ligne',
  'issuingOfficer.alt': 'Agent émetteur',
  'placeOfIssue': 'Lieu d’émission',
  'tooltip.hasBeenCorrected': 'Cette demande a été corrigée par le demandeur.',
  'tooltip.extendStay': 'Prolonger le séjour du demandeur',
  'decisionLetter.title': 'Lettre Officielle de Décision de Visa',
  'decisionLetter.approval.title': 'Demande de visa approuvée',
  'decisionLetter.refusal.title': 'Demande de visa refusée',
  'decisionLetter.applicationId': 'ID de la demande',
  'decisionLetter.approvalDate': 'Date d\'approbation',
  'decisionLetter.refusalDate': 'Date du refus',
  'decisionLetter.dear': 'Cher',
  'decisionLetter.applicant': 'Demandeur',
  'decisionLetter.documentType.application': 'Demande de visa',
  'decisionLetter.documentType.extension': 'Prolongement de séjour',
  'decisionLetter.logo.left': 'Département de l\'Immigration',
  'decisionLetter.logo.right': 'République',
  'decisionLetter.actRef': 'Loi sur l\'Immigration',
  'decisionLetter.chiefDirector': 'DIRECTEUR GÉNÉRAL DE L\'IMMIGRATION',
  'decisionLetter.approval.body1': 'Votre demande de visa a été approuvée.',
  'decisionLetter.approval.body2': 'Veuillez présenter le code QR ci-joint à votre arrivée à un point d\'entrée (PoE).',
  'decisionLetter.refusal.body1': 'Votre demande de visa n\'a pas été approuvée.',
  'decisionLetter.refusal.body2': 'Si nécessaire, vous pouvez soumettre une nouvelle demande en veillant à corriger tout élément ayant pu conduire à ce refus.',
  'decisionLetter.signature': 'Au nom du Directeur Général de l\'Immigration.',
  'printApprovalLetter': 'Imprimer la lettre d’approbation',
  'operation.REFUSEOUT': 'Sortie refusée',
  'operation.REFUSEIN': 'Entrée refusée',
  'error.closeApplication': 'Une erreur est survenue lors de la fermeture de la demande. Veuillez réessayer.',
  'closeApplication': 'Marquer comme fermée',
  'tooltip.closeApplication': 'Marquer la demande comme fermée. Cette action est irréversible.',
  'understand': 'Je comprends',
  'ExtraDocument1': 'Document supplémentaire n°1',
  'ExtraDocument2': 'Document supplémentaire n°2',
  'ExtraDocument3': 'Document supplémentaire n°3',
  'ExtraDocument4': 'Document supplémentaire n°4',
  'ExtraDocument5': 'Document supplémentaire n°5',
  'paperSize': 'Largeur du papier',
  'change_lang': 'Changer de langue',
  'queue.export.desc': 'Souhaitez-vous exporter la file d’attente actuelle vers un fichier JSON ? <b>Votre file d’attente locale sera supprimée après l’exportation</b>. Êtes-vous sûr de vouloir continuer ?',
  'queue.export': 'Exporter en JSON',
  'queue.import': 'Importer la file d’attente depuis un JSON',
  'tooltip.prepareLandingVisa.desc': '<b>Avertissement</b>, cette demande peut ne pas être dans l’état correct. Veuillez vérifier attentivement le document fourni par le client pour confirmer l’état exact de cette demande. Étant donné que vous êtes en <b>mode {consumeMode}</b>, vous avez la possibilité de <b>forcer le traitement en tant que {transfertMode}</b>, même si l’état actuel ne le permet généralement pas, si vous le jugez nécessaire',
  'nationality': 'Nationalité',
  'request.viewOutOfState.button': 'Forcer "{consumeMode}"',
  'HQReference': 'Référence du QG',
  'gender': 'Genre',
  'global.resetDefaults': 'Réinitialiser par défaut',
  'shortcuts.desc': 'Vous pouvez définir vos propres raccourcis clavier ci-dessous. Cliquez sur la touche que vous souhaitez définir comme raccourci et appuyez sur la touche souhaitée sur votre clavier.',
  'press.key': 'Appuyez sur une touche pour définir le raccourci...',
  'dashboard.keyboardShortcuts': 'Raccourcis clavier',
  'tooltip.changeShortcuts': 'Modifier les raccourcis clavier',
  'global.changeShortcuts': 'Modifier les raccourcis',
  'retake_picture': 'Reprendre la photo',
  'picture': 'Photo',
  'error.faceCheck': 'Une erreur est survenue lors du traitement de la correspondance faciale. Veuillez réessayer.',
  'faceCheck.see_score': 'Correspondance faciale',
  'recommendOrNot': 'Recommander ou non',
  'recommended': 'Recommandé',
  'not_recommended': 'Non recommandé',
  'error.downgrade': 'Une erreur est survenue lors du déclassement de la demande. Veuillez réessayer.',
  'done.downgrade': 'La demande a été rétrogradée avec succès.',
  'request.downgrade': 'Rétrograder',
  'tooltip.delayed': 'Cette demande est en retard',
  'movement.tooltip': 'Voir les détails des mouvements de la demande.',
  'request.extendStay': 'Prolonger le séjour',
  'ResidencePermitNumber': 'Numéro du permis de séjour',
  'error.payment.noInternalReference': 'Une référence HQ est requise pour que cette demande soit examinée. Veuillez attendre que la référence soit fournie.',
  'request.revision': 'Souhaitez-vous activer l’Autoskip ? Cette fonctionnalité permettra de passer automatiquement les étapes examinées qui ne nécessitent pas votre intervention.',
  'notice.BORDER_PASS': 'Passage frontalier',
  'form.borderPassNumber': 'Numéro du passage frontalier',
  'form.dateOfBirth': 'Date de naissance',
  'form.issueDate': 'Date d’émission',
  'form.authorizedCrossingPoints': 'Points de passage autorisés',
  'form.issuedBy': 'Délivré par',
  'form.externalCode': 'Code externe (OACI)',
  'err.invoke': 'Erreur',
  'ask.pendingRequest': 'Vous avez une correction en attente. Souhaitez-vous l’ouvrir maintenant ?',
  'entry.confirmation': 'Êtes-vous sûr que toutes les informations fournies sont correctes ? En cliquant sur "Confirmer", vous soumettrez la demande.',
  'free': 'Gratuit',
  'last_update': 'Dernière mise à jour',
  'count': 'Nombre',
  'tooltip.linkedExtensions': 'Il s’agit d’une prolongation de séjour. Cliquez pour voir les détails.',
  'extension': 'Extension',
  'client.extended.badPaymentMetadata': 'Les métadonnées de paiement sont invalides. Veuillez réessayer ou contacter le support si le problème persiste.',
  'DaysRequested': 'Jours demandés',
  'extensions.desc': 'Prolongation(s) de séjour en attente d’examen',
  'extend': 'Prolonger',
  'CheckboxVisaExtendFees': 'Je confirme que les informations fournies sont exactes et je suis d’accord avec les frais de prolongation de séjour, les conditions et la politique de confidentialité.',
  'AttestantDocument': 'Document de l’attestant',
  'AffidavitCustody': 'Affidavit de garde',
  'CopyOfEntry': 'Copie de l’entrée',
  'DepartureTicket': 'Billet de départ',
  'DYN.Self': 'Soi-même',
  'DYN.Spouse/Dependent': 'Conjoint/Dépendant',
  'DYN.Employee/Employer': 'Employé/Employeur',
  'DYN.Co-Director': 'Co-Directeur',
  'DYN.Lawyer': 'Avocat',
  'VisaReference': 'Référence de visa',
  'ReasonForExtension': 'Raison de la prolongation',
  'AttestantID': 'ID de l’attestant',
  'AttestantName': 'Nom de l’attestant',
  'AttestantPhone': 'Téléphone de l’attestant',
  'AttestantEmail': 'Email de l’attestant',
  'AttestantAddress': 'Adresse de l’attestant',
  'AttestantRelation': 'Relation de l’attestant',
  'start_extend': 'Prolonger le séjour',
  'visaExtend.title': 'Prolongation de séjour',
  'days': 'jours',
  'day': 'jour',
  'kiosk.standby.text1': 'Commencez par remplir votre déclaration en quelques clics sur cette tablette ou en ligne.',
  'kiosk.standbyDesc.text1': 'Avant de commencer, veuillez noter les informations suivantes:',
  'kiosk.standbyDesc.li1': 'Vous remplirez un formulaire électronique qui recueille vos données personnelles et les détails de votre voyage.',
  'kiosk.standbyDesc.li2': 'Toutes les informations fournies doivent être exactes et correspondre à vos documents de voyage (passeport, visa, etc.).',
  'kiosk.standbyDesc.li3': 'Après avoir rempli le formulaire, vous pouvez vous rendre directement au guichet d’immigration avec vos documents d’identification.',
  'kiosk.standbyDesc.li5': 'Si vous avez des difficultés, n’hésitez pas à demander de l’aide au personnel du poste frontière.',
  'kiosk.standbyDesc.text2': 'Cliquez sur "Commencer" lorsque vous êtes prêt à remplir votre déclaration d’entrée.',
  'kiosk.success.title': 'Demande soumise avec succès',
  'kiosk.success.text1': 'Vous pouvez maintenant vous rendre au guichet d’immigration avec vos documents de voyage. Un agent effectuera les vérifications finales et validera votre entrée dans le pays.',
  'kiosk.success.text2': 'Si vous avez des questions ou des difficultés, n’hésitez pas à demander de l’aide au personnel disponible.',
  'confirm.revision': 'Confirmer la correction',
  'print.isDone': 'L’avis a-t-il été imprimé avec succès ? Veuillez vous assurer de fournir l’avis imprimé au demandeur.',
  'form.hostPhone': 'Téléphone de l’hôte',
  'transit': 'Transit',
  'conditionalEntry': 'Entrée conditionnelle',
  'departure': 'Départ',
  'form.paragraph': 'Paragraphe',
  'form.dateOfRefusal': 'Date de refus',
  'form.purpose': 'Raison',
  'form.host': 'Hôte',
  'form.officer': 'Agent',
  'form.reportAt': 'Lieu de rapport',
  'form.reportOn': 'Date de rapport',
  'form.reportInterval': 'Intervalle de rapport',
  'notice.desc.RESTRICTION': 'L’avis de restriction provisoire informe le demandeur des documents requis pour compléter le processus. Vous pouvez sélectionner les documents manquants que le demandeur doit fournir dans un délai imparti.',
  'notice.REFUSAL': 'Avis de refus d’entrée',
  'notice.desc.REFUSAL': 'Le demandeur se voit refuser l’entrée dans le pays.',
  'notice.acknowledge': 'Je reconnais par la présente avoir reçu cet avis.',
  'notice.desc.REPORTING': 'L’avis au visiteur permet au demandeur d’entrer dans le pays, mais peut être soumis à des rapports supplémentaires. Vous pouvez sélectionner les documents manquants que le demandeur doit fournir dans un délai imparti.',
  'form.stationReference': 'Référence de la station',
  'form.fullNames': 'Nom complet',
  'form.reportLocation': 'Lieu de rapport',
  'form.daysUntilReport': 'Nombre de jours avant le rapport',
  'form.otherMissingDocument': 'Autre document manquant',
  'form.residentialAddress': 'Adresse résidentielle',
  'form.businessAddress': 'Adresse de l’entreprise',
  'form.hqReference': 'Référence du QG',
  'residentPermit': 'Permis de séjour',
  'notice.title': 'Avis disponibles à imprimer',
  'notice.desc': 'Veuillez sélectionner un avis dans la liste ci-dessous. Après avoir rempli les champs requis, vous pouvez imprimer l’avis pour le demandeur.',
  'notice.RESTRICTION': 'Avis de restriction provisoire',
  'notice.REPORTING': 'Avis au visiteur',
  'notice.RESTRICTION.desc': 'Le demandeur doit fournir les documents manquants dans un délai imparti.',
  'notice.REFUSAL.desc': 'Le demandeur se voit refuser l’entrée dans le pays.',
  'notice.REPORTING.desc': 'Le demandeur est autorisé à entrer, mais peut être soumis à des rapports supplémentaires.',
  'passportType.kioskWarning': 'La nationalité sélectionnée est soumise au régime de la catégorie C. Veuillez vous rendre immédiatement chez un agent d’immigration.',
  'free.charge.total': 'Total gratuit',
  'err.entryPoints': 'Une erreur est survenue lors du chargement des points d’entrée prévus',
  'summary.your_meta': 'Vos données (cliquez pour ouvrir)',
  'summary.payOnline': 'Je préfère payer en ligne maintenant plutôt qu’au guichet de l’agent à l’arrivée.',
  'summary.payOnline.desc': 'Sélectionner l’option ci-dessous vous amène à la page de paiement. Si vous choisissez de ne pas payer en ligne, vous paierez les frais de visa au guichet de l’agent à l’arrivée pour les types de visa "Visa à l’arrivée".',
  'summary.meta': ' Informations (cliquez pour ouvrir)',
  'EmergencyLastName': 'Nom de famille du contact d’urgence',
  'EmergencyFirstName': 'Prénom du contact d’urgence',
  'EmergencyEmail': 'Email du contact d’urgence',
  'EmergencyPhone': 'Téléphone du contact d’urgence',
  'person.name': 'Nom de la personne sélectionnée',
  'DYN.identity-card': 'Carte d’identité',
  'DYN.resident-permit': 'Permis de séjour temporaire',
  'DYN.identity-card.desc': 'Une carte d’identité est un document délivré par le gouvernement utilisé à des fins d’identification nationale.',
  'DYN.resident-permit.desc': 'Un permis de séjour temporaire est un document officiel délivré par un gouvernement permettant à un ressortissant étranger de résider dans un pays pour une durée déterminée.',
  'NonOrdinaryPassMission': 'Raison de la visite officielle',
  'PreviousConvictionsHomeAsk': 'Avez-vous, ou un de vos dépendants, été condamné pour un crime dans votre pays d’origine ?',
  'PlaceOfBirthCountry': 'Pays de naissance',
  'PlaceOfBirthCity': 'Ville de naissance',
  'OtherName': 'Autre(s) nom(s)',
  'travelName': 'Référence de la demande',
  'plannedEntry': 'Port d’entrée prévu',
  'summary.title': 'Résumé',
  'urgent': 'Urgent',
  'visaType': 'Type de document',
  'passportType': 'Type d’identification',
  'passportType.acknowledge': 'En sélectionnant ce type de passeport, vous reconnaissez que le non-respect des conditions d’utilisation peut entraîner un refus d’entrée.',
  'passportType.selectRefugeeNationality': 'Sélectionner la nationalité pour le passeport de réfugié <br>',
  'form.travelName.already': '<b>Cette demande a déjà été soumise avec la référence de demande ci-dessous. Si vous souhaitez modifier la référence, veuillez commencer une nouvelle demande.</b>',
  'application.current_person': 'Vous modifiez actuellement la demande pour',
  'DYN.USD': '$ USD',
  'DYN.EUR': '€ EUR',
  'DYN.ZWL': 'ZWL',
  'DYN.GBP': '£ GBP',
  'DYN.BWP': 'BWP',
  'DYN.KMF': '(KM)F',
  'participants.edit': 'Modifier les demandeurs',
  'request.existSaved': 'Une demande enregistrée a été trouvée, souhaitez-vous charger ses données ? (Si vous cliquez sur "non", la demande sera supprimée et vous commencerez une nouvelle)',
  'participant.hasData': 'Vous avez déjà saisi des données pour ce participant. Si vous continuez, les données seront perdues. Êtes-vous sûr de vouloir continuer ?',
  'participant.selectAtLeastOne': 'Veuillez sélectionner au moins un participant pour continuer.',
  'participants.title': 'Demandeur(s)',
  'participants.desc': 'Veuillez vous sélectionner vous-même et/ou la ou les personnes qui feront partie de cette demande.</br><b>Le paiement à la fin sera effectué pour toutes les personnes sélectionnées.</b></br></br>Vous pouvez ajouter/retirer une personne ou modifier sa demande à tout moment en cliquant sur le nom qui apparaîtra au-dessus du formulaire.</br></br>{participantText}',
  'participant.ready': 'Lorsque vous êtes prêt, cliquez sur "Continuer".',
  'participant.missing': 'Avant de continuer, veuillez enregistrer au moins une personne.',
  'travelName.title': 'Référence de la demande',
  'form.travelName': 'Référence de la demande',
  'form.travelName.desc': 'La référence de la demande sera utilisée pour identifier plus facilement votre demande.',
  'nationality.title': 'Nationalité',
  'nationality.desc': 'Veuillez sélectionner votre pays selon le passeport que vous utilisez.',
  'passportType.title': 'Type de document',
  'passportType.desc': 'Veuillez sélectionner le type de document de voyage que vous utilisez pour cette demande.',
  'visaType.title': 'Type de visa',
  'visaType.desc': 'Veuillez sélectionner le type de visa pour lequel vous souhaitez faire une demande. Cette liste varie selon votre nationalité et le type de passeport.',
  'urgent.title': 'Visa Normal/Urgent',
  'urgent.desc': 'Si cette demande de visa est <b>urgente</b>, sélectionnez cette option. Le temps de traitement sera plus court, mais un <b>frais supplémentaire</b> sera facturé pour ce service.</br></br>',
  'priority.normal': 'Normale',
  'priority.urgent': 'Urgent',
  'priority.normal.DYN.desc': 'Traité dans un délai de sept (7) jours ouvrables.',
  'priority.urgent.DYN.desc': 'Traité dans un délai de trois (3) jours ouvrables.',
  'visa.paidOnArrival.title': 'Visa payé à l’arrivée',
  'visa.paidOnArrival.desc': 'Permet aux voyageurs éligibles d’obtenir un visa à l’arrivée au port d’entrée, simplifiant ainsi le processus d’entrée pour les séjours de courte durée.',
  'visa.paidOnline.title': 'Visa payé en ligne',
  'visa.paidOnline.desc': 'Permet une ou plusieurs entrées dans le pays pendant une période d’un (1) mois, nécessitant un nouveau visa pour les entrées ultérieures.',
  'PassportType': 'Type de passeport',
  'PassportCountry': 'Pays émetteur du passeport',
  'form.passportCountry': 'Pays émetteur du passeport',
  'DYN.ordinary': 'Passeport ordinaire',
  'DYN.diplomatic': 'Passeport diplomatique',
  'DYN.DIPLOMATIC': 'Passeport diplomatique',
  'DYN.ORDINARY': 'Passeport ordinaire',
  'DYN.SERVICE': 'Passeport de service',
  'DYN.official': 'Passeport officiel',
  'supervision.nofee': 'Validation par un superviseur requise pour une demande sans pénalité.',
  'NoFeeProof': 'Justificatif d\'exonération',
  'webcam.nofeeProof.confirm': 'Veuillez prendre en photo le document justificatif d\'exonération (No Fee Proof).',
  'open.register': 'Ouvrir le registre',
  'DYN.service': 'Passeport de service',
  'DYN.refugee': 'Passeport de réfugié ou Titre de Voyage',
  'DYN.ordinary.desc': 'Un passeport ordinaire est le type de passeport le plus courant, délivré aux citoyens à des fins de voyage général.',
  'DYN.diplomatic.desc': 'Un passeport diplomatique est délivré aux diplomates et consuls pour les voyages et séjours officiels à l’étranger.',
  'DYN.refugee.desc': 'Un passeport de réfugié est délivré par un pays aux personnes qu’il reconnaît comme réfugiées pour leur permettre de voyager à l’étranger.',
  'DYN.official.desc': 'Un passeport officiel est délivré aux employés du gouvernement pour les voyages et séjours officiels à l’étranger.',
  'DYN.service.desc': 'Un passeport de service est délivré aux employés du gouvernement pour les voyages et séjours officiels à l’étranger.',
  'DYN.marine': 'Passeport maritime',
  'DYN.marine.desc': 'Un passeport maritime est délivré aux marins et membres d’équipage pour les voyages et séjours à l’étranger.',
  'DYN.laissez-passer': 'Laissez-passer',
  'DYN.laissez-passer.desc': 'Un laissez-passer est un document de voyage délivré par les Nations Unies ou ses agences pour les voyages et séjours officiels à l’étranger.',
  'Urgent': 'Ceci est une demande urgente. Je comprends que le temps de traitement sera plus court, mais les frais seront plus élevés.',
  'photo.passport.scanned': 'Passeport scanné maintenant',
  'review.nr.final': 'Examen final',
  'review.nr': 'Examen n° ',
  'err.ArrivalDate.maxDateMilliTo': 'Une période d’au moins six (6) mois entre la date d’expiration de votre passeport et la date de votre arrivée dans le pays est requise. Veuillez renouveler ce passeport avant de faire une demande de visa.',
  'err.DateOfExpiry.maxDateMilliTo': 'Votre passeport expire dans moins de six (6) mois à compter de la date d’arrivée dans le pays. Veuillez renouveler ce passeport avant de faire une demande de visa.',
  'place.update.error': 'Une erreur est survenue lors de la mise à jour du lieu',
  'dashboard.kiosk.start': 'Commencer le processus',
  'form.role.kiosk': 'Kiosque',
  'FundsAvailable': 'Montant',
  'FundsAvailableCurrency': 'Devise',
  'emergency_contact_text': 'En cas d’urgence, veuillez fournir les coordonnées d’une personne à contacter.',
  'emergency_contact': 'Contact d’urgence / Proche',
  'internet.lost': 'Connexion Internet perdue.</br> Veuillez vérifier votre connexion.',
  'err.DateOfExpiry.maxDateMilliFromToday': 'Votre passeport expire dans moins de six (6) mois à compter d’aujourd’hui. Veuillez renouveler ce passeport avant de faire une demande de visa.',
  'err.DepartureDate.maxDateMilliFrom': 'La date de départ est trop éloignée de la date d’arrivée. Veuillez vous référer à la durée limite du visa.',
  'requirements': 'Exigences',
  'err.file.size': 'La taille du fichier est trop grande. La taille maximale est de : ',
  'revision.success': 'Votre mise à jour de la demande a été soumise avec succès. Vous recevrez un email avec le code QR dès qu’elle sera approuvée.',
  'revision.free': 'Révision gratuite',
  'revision.start': 'Nous avons pris soin de remplir les champs avec les informations que vous avez fournies lors de la demande initiale, sauf pour les champs qui posent problème. Veuillez vérifier les informations et les corriger. Souhaitez-vous continuer ?',
  'file_uploaded': 'Fichier déjà téléchargé et stocké',
  'refusal.desc2': 'Les champs suivants posent problème :',
  'start_correction': 'Commencer la correction',
  'payment.selectMode': 'Veuillez sélectionner les champs qui posent problème. Vous pouvez sélectionner plusieurs champs.',
  'suspendReason.desc': 'Veuillez écrire une brève description de la demande de correction. Cette description sera envoyée au demandeur avec les champs problématiques sélectionnés.',
  'err.ArrivalDate.mustBeEqualOrBefore': 'La date d’arrivée doit être égale ou antérieure à la date de départ',
  'err.DepartureDate.mustBeEqualOrAfter': 'La date de départ doit être égale ou postérieure à la date d’arrivée',
  'qr.request_desc': 'Ce code QR sert de laissez-passer numérique pour le traitement des visas. Le gouvernement se réserve le droit d’approuver ou de refuser l’entrée au moment du contrôle des visas.',
  'request_state.PENDING': 'En attente',
  'document.Screening': 'Pré-vérification',
  'err.SpouseBirthDay.max': 'Date de naissance du conjoint invalide',
  'err.ArrivalDate.min': 'Date d’arrivée invalide',
  'err.DepartureDate.min': 'Date de départ invalide',
  'err.DateOfIssue.max': 'Date d’émission invalide',
  'err.BirthDay.max': 'Date de naissance invalide',
  'err.dependants_date_of_birth.max': 'Date de naissance du dépendant invalide',
  'err.DateOfExpiry.min': 'Date d’expiration invalide',
  'dependants': 'Dépendants',
  'PassportPhoto': 'Photo récente',
  'PassportScan': 'Page des données biographiques du passeport',
  'EventInvitationLetter': 'Lettre d’invitation à l’événement',
  'ProofOfResidenceHost': 'Justificatif de résidence/réservation de l\'hôte (signé)',
  'BusinessLetter': 'Lettre d\'entreprise/lettre individuelle',
  'BusinessProfile': 'Un profil d’entreprise est requis',
  'InvitationLetterAndBusinessProfile': 'Lettre d’invitation et documents d’entreprise hôte (signés)',
  'SpouseFullName': 'Nom complet du conjoint',
  'SpousePassportNumber': 'Numéro de passeport du conjoint',
  'SpouseBirthDay': 'Date de naissance du conjoint',
  'SpousePlaceOfBirth': 'Lieu de naissance du conjoint',
  'ArrivalDate': 'Date d’arrivée',
  'DepartureDate': 'Date de départ',
  'DateOfIssue': 'Date d’émission',
  'DateOfExpiry': 'Date d’expiration',
  'HostName': 'Nom de l’hôte',
  'PurposeOfVisit': 'Raison de la visite',
  'existingValidEntryReferenceOfficer': "Agent de référence d'entrée",
  'male': 'Homme',
  'female': 'Femme',
  'other': 'Autre',
  'single': 'Célibataire',
  'married': 'Marié',
  'separated': 'Séparé',
  'divorced': 'Divorcé',
  'widowed': 'Veuf',
  'select_reason_first': 'Veuillez sélectionner la raison de la visite à la page précédente pour voir la liste des documents requis.',
  'visaIntro.title': 'Demande',
  'remove': 'Supprimer',
  'dependant_add': 'Ajouter un dépendant',
  'dependant': 'Dépendant',
  'upload_file': 'Télécharger un fichier (< {size})',
  'AddressAtDestination': 'Adresse à destination',
  'HostInvitationLetter': 'Lettre d’invitation de l’hôte',
  'ProofOfResidence': 'Preuve de résidence',
  'ApplicationLetter': 'Lettre de demande',
  'ResidentialStatusOfHost': 'Statut résidentiel de l’hôte',
  'ReasonOfVisitProof': 'Preuve de la raison de la visite',
  'InvitationLetter': 'Lettre d’invitation',
  'LetterOfAcceptanceFromSchool': 'Lettre de confirmation',
  'DYN.male': 'Homme',
  'DYN.female': 'Femme',
  'DYN.other': 'Autre',
  'DYN.single': 'Célibataire',
  'DYN.married': 'Marié',
  'DYN.separated': 'Séparé',
  'DYN.divorced': 'Divorcé',
  'DYN.widowed': 'Veuf',
  'DYN.married_according_to_custom': 'Marié selon les coutumes',
  'DYN.religiously_married': 'Marié selon les coutumes religieuses',
  'passport.valid': 'Le document scanné ne semble pas avoir été altéré ou révoqué et est signé par le pays émetteur.',
  'travel_information_title': 'Attention',
  'visaPrice.desc': 'Vous serez tenu de procéder à ce paiement par Visa ou MasterCard à la fin de la demande. Ce paiement est non remboursable.',
  'visaPrice': 'Prix du visa',
  'required': 'Requis',
  'DYN.holiday_visa': 'Vacances',
  'DYN.live_here': 'Résident à long terme',
  'DYN.business_visa': 'Affaires',
  'DYN.conferencing_visa': 'Conférence',
  'DYN.transit_visa': 'Transit',
  'DYN.student_visa': 'Études',
  'DYN.sports_visa': 'Sport',
  'DYN.arts_visa': 'Art',
  'DYN.other_visa': 'Autre',
  'DYN.event_visa': 'Événement',
  'document': 'Document',
  'documents_attached': 'Documents à joindre',
  'Dependants': 'Dépendants',
  'Spouse': 'Conjoint',
  'BirthCity': 'Ville de naissance',
  'ReferencePreviousVisa': 'Référence du visa précédent',
  'PreviousConvictionsHome': 'Nature de la/les condamnation(s) dans le pays d’origine',
  'travel_information': 'Informations sur le voyage',
  'PlaceofIssue': 'Lieu d’émission',
  'Email': 'Email',
  'Phone': 'Numéro de téléphone',
  'form.selectCountry': 'Sélectionner un pays',
  'Occupation': 'Profession',
  'HomeAddress': 'Adresse résidentielle actuelle',
  'InvitingCompanyName': 'Nom de la société invitante',
  'form.importantRead': 'IMPORTANT - LIRE ATTENTIVEMENT',
  'form.completeInEnglish': 'À remplir clairement en anglais.',
  'form.selectApplicableFields': 'Sélectionnez tous les champs applicables ci-dessous.',
  'form.seniority': 'Niveau d’ancienneté',
  'LastName': 'Nom de famille',
  'FirstName': 'Prénom(s)',
  'BirthDay': 'Date de naissance (Exactement comme sur le passeport)',
  'PlaceOfBirth': 'Lieu de naissance',
  'Gender': 'Genre',
  'MaritalStatus': 'Statut matrimonial',
  'CheckboxVisaFees': 'Je confirme que les informations fournies sont exactes et je suis d’accord avec les frais de visa, les conditions d’utilisation et la politique de confidentialité.',
  'PassportNumber': 'Numéro de passeport',
  'VisaType': 'Type de visa',
  'visitor_details': 'Détails du demandeur',
  'personal_details': 'Détails personnels',
  'contact_details': 'Détails de contact',
  'miscellaneous_details': 'Détails du voyage',
  'spouse_details': 'Détails du conjoint',
  'payment': 'Paiement',
  'global.scan_qr': 'Vérifier un code QR',
  'qr.nosuch': 'Chargement... Le code QR n’est pas encore trouvé dans le système. Vérifiez la connexion Internet.',
  'qr.faked': 'La réponse du serveur est que le code QR n’existe pas. Il est très probablement faux !',
  'qr.quicklook': 'Informations clés',
  'global.toPayments.DYN.': 'Voir les demandes',
  'payment.duplicate.open': 'Ouvrir le nouveau paiement ?',
  'ONE_DAY': '1 jour',
  'THREE_DAYS': '3 jours',
  'ONE_WEEK': '1 semaine',
  'TWO_WEEKS': '2 semaines',
  'ONE_MONTH': '1 mois',
  'TWO_MONTHS': '2 mois',
  'SIX_MONTHS': '6 mois',
  'ONE_YEAR': '1 an',
  'place_created.desc': 'Le nouveau lieu a été créé et est maintenant utilisable.',
  'payment_status.DYN.NONE': '-- Pas de filtre --',
  'dropdown.state': 'Statut',
  'payment.qrList.title': 'Liste des paiements QR',
  'see.qr_list': 'Voir la liste des codes QR',
  'form.role.partner_registrer': 'Registre des partenaires',
  'form.reason': 'Raison',
  'global.reject': 'Rejeter',
  'payment.validate_desc': 'Êtes-vous sûr de vouloir valider ce paiement ?',
  'payment.reject_desc': 'Êtes-vous sûr de vouloir rejeter ce paiement ? N’oubliez pas d’ajouter une raison.',
  'qr.title': 'Code QR',
  'dashboard': 'Tableau de bord',
  'downgrade.type.label': 'Type de visa cible',
  'PreviousVisa': 'Visa précédent',
  'err.PreviousVisa.required': 'Le visa précédent est requis',
  'err.approveRefuse.required': 'Veuillez sélectionner si vous souhaitez recommander ou non.',
  'multipleEntry.warning': 'Attention : les visas à entrées multiples ne sont accordés qu’aux personnes ayant déjà obtenu au moins un visa valide par le passé. Une copie d’un visa précédent sera exigée.',
  'ask.downgradeType': 'Choisissez le type de visa cible',
  'ask.downgrade.multiple': 'Etes vous sur de vouloir rétrograder ce visa à {type} ?',
  'dashboard.people.DYN.': 'Personnes enregistrées',
  'dashboard.my_account': 'Mon compte',
  'form.id': 'ID',
  'payments.scan': 'Scanner le QR',
  'print.qr.desc': 'Ce code QR est unique et sécurisé, ne peut être utilisé que le nombre de fois spécifié. Ne l’altérez pas pour qu’il reste utilisable.',
  'print.qr.title': 'Code QR',
  'print.informations': 'Informations',
  'print.notice.folding': 'Instructions de pliage',
  'print.notice.desc2': 'En cas de question concernant ce document, veuillez contacter le support par téléphone ou email.',
  'print.notice.desc1': 'Gardez ce document à l’abri de l’eau ou des flammes.',
  'print.notice.title': 'Avis',
  'client.extended.openSuchPayment': 'Un paiement est déjà actif pour cet utilisateur',
  'form.externalId': 'Référence de paiement',
  'form.userExternalId': 'ID externe',
  'global.confirm': 'Confirmer',
  'global.submit': 'Soumettre',
  'global.back': 'Retour',
  'global.close': 'Fermer',
  'global.contact_support': 'Contacter le support',
  'global.previous': 'Précédent',
  'global.next': 'Suivant',
  'global.accept': 'Accepter',
  'global.support': 'Support',
  'global.consume': 'Consommer',
  'global.validate': 'Valider',
  'global.reset': 'Réinitialiser',
  'global.delete': 'Supprimer',
  'global.update': 'Mettre à jour',
  'global.download': 'Télécharger',
  'global.print': 'Imprimer',
  'global.print_c7': 'Imprimer le ticket',
  'global.checkIn': 'Enregistrement',
  'choose-lang.title': 'Préférence de langue',
  'choose-lang.desc': 'Veuillez choisir la langue qui sera utilisée pour l\'application.',
  'global.personalNum': 'N° personnel',
  'global.passportNum': 'N° de passeport',
  'global.add': 'Ajouter',
  'global.block': 'Bloquer',
  'global.blocked': 'Bloqué',
  'global.unblock': 'Débloquer',
  'global.daily_otp': 'Code quotidien',
  'global.refresh': 'Rafraîchir',
  'global.connect': 'Connecter',
  'global.disconnect': 'Déconnecter',
  'form.email': 'Email',
  'form.name': 'Nom',
  'form.firstName': 'Prénom(s)',
  'form.lastName': 'Nom de famille',
  'form.password': 'Mot de passe',
  'form.password2': 'Retaper le mot de passe',
  'form.linkType': 'Quel est le lien de cette personne avec vous ?',
  'form.userId': 'ID utilisateur',
  'form.parentId': 'ID parent',
  'form.amount': 'Montant',
  'form.currency': 'Devise',
  'form.buyingOption': 'Document acheté',
  'form.place': 'Lieu',
  'form.role': 'Rôle',
  'form.connectUAPattern': 'Modèle d’agent utilisateur',
  'form.connectIPRange': 'Plage d’IP',
  'form.state': 'État',
  'form.created_date': 'Date de création',
  'form.created_place': 'Lieu de création',
  'form.consumed_place': 'Lieu consommé',
  'form.email_code': 'Code de l’email',
  'form.phone': 'Numéro de téléphone',
  'form.worker': 'ID employé',
  'form.password_old': 'Mot de passe actuel',
  'form.password_new': 'Nouveau mot de passe',
  'form.idCard': 'N° de carte d’identité',
  'form.type.CASH': 'Espèces',
  'form.type.CARD': 'Carte',
  'form.role.customer': 'Client',
  'form.role.worker': 'Employé',
  'yes': 'Oui',
  'no': 'Non',
  'form.borderPass': 'Émettre un passage frontalier',
  'form.role.orbis_consumer': 'Consommateur Orbis',
  'form.role.admin': 'Administrateur',
  'form.perm2.DYN.': 'Consommer une demande de document',
  'form.perm3.DYN.': 'Examiner une demande de document',
  'form.perm4.DYN.': 'Créer/gérer des lieux, utilisateurs et demandes de document',
  'form.perm5.DYN.': 'Examiner une demande de prolongation',
  'client.extended.clientNotAllowed': 'Votre compte n’est actuellement pas autorisé sur ce lieu. Veuillez vérifier vos paramètres de connexion.',
  'err.submit': 'Erreur lors de la soumission du formulaire',
  'err.place.required': 'Le lieu est requis',
  'helps.showProceed': 'Montrer la procédure',
  'helps.showScan': 'Montrer le document à scanner',
  'payment_status.DYN.undefined': 'État actuel - aucune opération',
  'client.extended.missingResourceLogin': 'Impossible de se connecter, identifiants incorrects',
  'client.extended.linkedAccountExists': 'Un compte avec cet email existe déjà',
  'client.extended.attachedPayments': 'Vous ne pouvez pas modifier cette personne, elle a déjà une demande liée à elle.',
  'client.extended.badPayload': 'Mauvaises informations dans la requête',
  'client.extended.placeNotAllowed': 'Le lieu n’est pas autorisé',
  'client.extended.locked': 'Le compte est verrouillé',
  'client.extended.clientBadOtp': 'Mauvais code quotidien',
  'client.extended.confirmationRequired': 'Confirmation requise',
  'confirmationRequired.email': 'Un lien de confirmation a été envoyé à votre adresse e-mail. Veuillez vérifier votre boîte de réception et confirmer avant de vous connecter.',
  'confirmationRequired.sms': 'Un lien de confirmation a été envoyé par SMS. Veuillez vérifier vos messages et confirmer avant de vous connecter.',
  'client.extended.badPaymentConfirmation': 'Le paiement ne peut pas aboutir : l\'une des vérifications a échoué',
  'time': 'Heure',
  'place': 'Lieu',
  'home.first': 'Votre compte est maintenant validé et vous pouvez vous connecter.',
  'payOnline': 'Payer en ligne',
  'login.sign_in': 'Se connecter',
  'photo.unavailable': 'Photo indisponible',
  'global.entry': 'Entrée',
  'global.exit': 'Sortie',
  'menu.users': 'Utilisateurs',
  'menu.places': 'Lieux',
  'create_user.title': 'Enregistrer un utilisateur',
  'create_payment.title': 'Créer un paiement',
  'create_place.title': 'Créer un lieu',
  'users.title': 'Base de données des utilisateurs',
  'payments.title': 'Base de données des paiements',
  'payments.download_csv': 'Télécharger le CSV',
  'payments.download_choice': 'Que voulez-vous télécharger ?',
  'payments.download_table': 'Le tableau affiché',
  'payments.download_filtered': 'Jusqu’à {value} lignes',
  'create_card_payment.title': 'Paiement en ligne',
  'places.title': 'Liste des lieux',
  'forgot_password.title': 'Réinitialiser le mot de passe',
  'welcome.title_1.DYN.': 'Bienvenue sur {appName}',
  'welcome.text_1.DYN.': 'Bienvenue sur le portail officiel {appName}.<br>Ce service en ligne simplifie vos démarches pour obtenir vos documents officiels de manière sûre et efficace.',
  'welcome.text_1.1.DYN.': 'Prêt(e) à découvrir comment cela fonctionne ? Allons-y !',
  'welcome.title_2.DYN.': 'Qu’est-ce que {appName} ?',
  'welcome.text_2.DYN.': '{appName} est une plateforme numérique sécurisée qui vous permet de demander facilement vos documents officiels en ligne : carte d’identité, passeport, titre de séjour, et plus encore.',
  'welcome.text_2.1.DYN.': 'Faites votre demande où que vous soyez et recevez vos documents par email, accompagnés d’un QR code unique garantissant leur authenticité.',
  'welcome.title_3.DYN.': 'En tant que travailleur',
  'welcome.text_3.DYN.': 'Avec {appName}, vous pouvez gérer les demandes hors ligne. Nous avons confiance en la sécurité et la fiabilité de notre génération de QR codes.',
  'welcome.text_3.1.DYN.': 'Vous pouvez aussi gérer les utilisateurs et les lieux de votre organisation.',
  'welcome.text_4.DYN.': 'Vous pouvez même gérer les demandes hors ligne. Nous avons confiance en la sécurité et la fiabilité de notre génération de QR codes.',
  'welcome.text_4.1.DYN.': 'Dès que vous êtes de nouveau en ligne, tout sera synchronisé automatiquement.',
  'welcome.title_5.DYN.': 'Commencez votre demande',
  'welcome.text_5.DYN.': 'Sur les pages suivantes, vous pourrez demander vos documents officiels en ligne en quelques clics.<br><br>Après validation de votre demande, vous recevrez vos documents par email, accompagnés d’un QR code sécurisé contenant toutes les informations nécessaires pour une vérification rapide et fiable.',
  'payment_status.DYN.PROPOSED': 'Paiement en attente',
  'payment_status.DYN.PAID': 'Prêt à l’enregistrement',
  'payment_status.DYN.PAID_NOT_CONFIRMED': 'En attente de vérification',
  'payment_status.DYN.USED': 'Sortie effectuée',
  'payment_status.DYN.DUPLICATED': 'Dupliqué',
  'payment_status.DYN.REFUNDED': 'Remboursé',
  'payment_status.DYN.EXPIRED': 'Refusé',
  'payment_status.DYN.PENDING': 'En attente de correction',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED': 'Payer plus tard - Non confirmé',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED.FREE': 'Gratuit - Non confirmé',
  'payment_status.DYN.DELAY_PAY': 'Prêt à payer à l’arrivée',
  'payments.validate': 'Confirmer',
  'documentContinue.title': 'Continuer vos achats',
  'bt.available_devices': 'Appareils Bluetooth disponibles',
  'bt.no_available_devices': 'Aucun appareil Bluetooth disponible détecté',
  'emailSend.title': 'Vérification de l’email',
  'emailSend.description': 'Pour valider votre compte, vous devez cliquer sur le lien contenu dans un email de validation envoyé à votre adresse email dans les 24 heures.',
  'emailValid.title': 'Compte validé',
  'emailValid.description': 'Votre compte {appName} a été validé avec succès. Vous pouvez maintenant accéder à votre espace personnel en vous connectant avec vos identifiants.',
  'documentManagement.title': 'Demande de visa',
  'preenroll.title': 'Pré-inscription',
  'passportEmbassy.title': 'Document de l’ambassade',
  'zwevisa.title': 'Visa',
  'passwordSend.title': 'Confirmation envoyée',
  'passwordSend.description': 'Vous avez reçu un email de confirmation avec un lien pour réinitialiser votre mot de passe. Vous avez 24 heures pour cliquer dessus.',
  'forgotPassword.title': 'Mot de passe oublié',
  'forgotPassword.description': 'Pour réinitialiser votre mot de passe, entrez votre email ci-dessous.',
  'forgotPassword.description.electron': 'Pour réinitialiser votre mot de passe, entrez votre email de compte ci-dessous. Si vous essayez de récupérer un mot de passe pour un compte <b>annuaire actif</b>, veuillez contacter le support.',
  'passwordNew.title': 'Nouveau mot de passe',
  'modifiedPassword.title': 'Mot de passe changé',
  'modifiedPassword.description': 'Le mot de passe a été changé. Veuillez vous reconnecter.',
  'people.title.DYN.': 'Personnes enregistrées',
  'people.addPerson.DYN.': 'Enregistrer une nouvelle personne',
  'meansPayment.title': 'Moyens de paiement',
  'onlinePayment.title': 'Paiement PayPal',
  'onlinePayment.pay': 'Payer',
  'qrPayment.title': 'Paiement par code QR',
  'form.expireDate': 'Date d’expiration',
  'successPayment.title': 'Confirmation de commande',
  'trackingControl.title.DYN.': 'Suivre cette demande',
  'modifyData': 'Modifier les données',
  'stopModifyData': 'Arrêter de modifier les données',
  'askVisa': 'Demander un visa',
  'peopleNew.title.DYN.': 'Nouvelle personne',
  'peopleFound.title.DYN.': 'Personne trouvée',
  'peopleFound.description.DYN.': 'La personne correspondant aux informations que vous avez saisies a été ajoutée à la liste des personnes enregistrées.',
  'payment.commandHistory': 'Historique des paiements',
  'menu.placesPerm': 'Lieux et autorisations',
  'block.message': 'Souhaitez-vous bloquer cet utilisateur ?',
  'menu.addPlace': 'Ajouter un lieu',
  'label.numberAccount': 'N° de compte',
  'place.sheet.open': 'Ouvrir la fiche du lieu',
  'place.delete': 'Supprimer le lien avec ce lieu',
  'place.update.success': 'Le lieu a été mis à jour avec succès.',
  'place.new': 'Nouveau lieu',
  'place.create': 'Créer un lieu',
  'place.add.ask': 'Souhaitez-vous lier ce lieu à cet utilisateur ?',
  'place.delete.link': 'Supprimer le lien avec ce lieu',
  'place.delete.link.ask': 'Êtes-vous sûr de vouloir délier ce lieu ?',
  'place.delete.link.done': 'Vous avez supprimé le lien avec le lieu avec succès.',
  'user.new': 'Nouvel utilisateur',
  'user.create': 'Enregistrer l’utilisateur',
  'user.created': 'La création du nouvel utilisateur a été réussie. Ce compte peut maintenant être utilisé.',
  'user.sheet.open': 'Ouvrir la fiche de l’utilisateur',
  'payment.sheet.open': 'Ouvrir la fiche de paiement',
  'err.createplace': 'Impossible de créer. L’ID existe déjà.',
  'place.parent': 'Lieu parent',
  'dropdown.qr': 'Scanner un code QR',
  'dropdown.pass': 'Scanner un document',
  'err.noReader': 'Le lecteur n’est pas connecté. Veuillez connecter le lecteur pour continuer.',
  'err.noCard': 'Aucun document biométrique valide détecté dans le lecteur. Cela peut être dû à l’utilisation d’un document non biométrique, à la présentation d’une copie non autorisée ou contrefaite, ou à un dysfonctionnement de l’antenne de lecture.',
  'err.noConnect': 'Ce document ne répond pas aux protocoles standard de l’ICAO. Cela peut être dû à l’utilisation d’un document non biométrique, à la présentation d’une copie non autorisée ou contrefaite, ou à un dysfonctionnement de l’antenne de lecture.',
  'err.noBAC': 'Le canal sécurisé vers le document n’a pas pu être établi, est-il authentique ? Vérifiez ce document manuellement et interrogez le titulaire.',
  'err.alteredDoc': 'Les champs du document n’ont pas pu être lus, est-il authentique ? Vérifiez ce document manuellement et interrogez le titulaire.',
  'err.revokedDocSigner': 'Le signataire de ce document a été révoqué par son autorité émettrice. Ce document pourrait avoir été signé de manière frauduleuse. Interrogez le titulaire de manière approfondie à ce sujet.',
  'err.unverifiedDoc': 'La validité du document n’a pas pu être vérifiée, erreur dans le protocole d’authentification, cela pourrait être un signe d’un document émis hors du pays selon la liste maître de l’ICAO, un document contrefait, ou un dysfonctionnement de l’antenne de lecture.',
  'err.noPassiveAuthentication': 'La validité du document n’a pas pu être vérifiée, erreur dans le protocole d’authentification, un document contrefait ou un dysfonctionnement de l’antenne de lecture.',
  'err.noResult': 'Aucun fichier trouvé',
  'payment.new.DYN.': 'Nouvelle sortie sans visa',
  'payment.created.register': 'Paiement enregistré',
  'payment.created': 'Votre paiement a été enregistré et est maintenant visible dans la liste des paiements.',
  'payment.created.qr': 'Un email contenant le code QR généré a été envoyé à l’adresse email fournie.',
  'idcard.number': 'Numéro de carte d’identité',
  'form.userCreator': 'Créé par l’utilisateur',
  'form.userRefund': 'Remboursé par l’utilisateur',
  'form.userConsumed': 'Consommé par l’utilisateur',
  'PRICEUP': 'Prix 0-9',
  'PRICEDOWN': 'Prix 9-0',
  'RECENT': 'Le plus récent',
  'LATEST': 'Le plus ancien',
  'STATUSUP': 'Statut a-z',
  'STATUSDOWN': 'Statut z-a',
  'payment.success': 'Votre paiement a été enregistré',
  'payment.consume.ask.DYN.': 'Voulez-vous vraiment enregistrer/sortir cette demande de document ?',
  'checkinOut.refuse': 'Voulez-vous vraiment refuser cette demande ?',
  'payment.duplicate': 'Dupliquer',
  'payment.duplicate.ask': 'Voulez-vous vraiment dupliquer ce paiement ?',
  'payment.duplicate.done': 'Votre paiement a été dupliqué avec succès',
  'tooltip.duplicatePayment': 'Dupliquer ce paiement pour permettre sa réutilisation',
  'payment.refund.ask': 'Voulez-vous vraiment rembourser ce paiement ?',
  'payment.refund.done': 'Votre paiement a été remboursé avec succès',
  'payment.refund.exist': 'Ce paiement a déjà été remboursé',
  'payment.paid.error': 'Votre paiement doit avoir le statut "Complet"',
  'block.done': 'Le compte a été bloqué',
  'block.unblock': 'Le compte a été débloqué',
  'place-add.add': 'Ajout du lieu',
  'permission.title': 'Autorisation requise : Caméra',
  'qr.see': 'Voir le code QR',
  'qr.desc.DYN.': 'Voici le code QR pour la demande. Il apparaîtra lors d’une impression et sera envoyé à l’adresse email saisie lors de l’inscription.',
  'dashboard.place.verif': 'Si vous n’avez pas entré de lieu, veuillez le faire',
  'block.yourself': 'Vous ne pouvez pas vous bloquer vous-même',
  'lastPlace.delete': 'Le dernier lieu de ce compte est sur le point d’être supprimé. Cela rendra ce compte inutilisable. Continuer ?',
  'place.add.done': 'Ce lieu a été ajouté à cet utilisateur avec succès',
  'no.connection': 'Pour accéder à cette page, vous devez être connecté à Internet. Veuillez vous reconnecter',
  'place.delete.success': 'Ce lieu a été supprimé.',
  'wrong.current': 'Vous avez saisi un mot de passe actuel incorrect',
  'no.place': 'Aucun lieu pour ce compte.',
  'email.error': 'Un email similaire existe déjà',
  'email.notexist': 'L’email n’existe pas',
  'one.payment': 'Vous devez avoir au moins un paiement créé et/ou filtré.',
  'err.client.extended.uuidUsed': 'Ce paiement a déjà été consommé',
  'client.extended.uuidUsed': 'Ce paiement a déjà été consommé',
  'no.activecamera': 'Aucune caméra active trouvée',
  'no.accessPermission': 'Ce compte n’a pas d’autorisation d’accès',
  'print.name': 'Imprimante',
  'print.success': 'Votre ticket a été imprimé',
  'print.need': 'Vous devez d’abord vous connecter à une imprimante pour pouvoir imprimer',
  'printer.connect': 'Vous êtes maintenant connecté à l’imprimante :',
  'permission.desc': 'Le service que vous souhaitez utiliser nécessite une autorisation pour utiliser la caméra de votre appareil',
  'createPeople.ask.DYN.': 'Voulez-vous vraiment enregistrer cette nouvelle personne ?',
  'createPeopleDuplicate.ask.DYN.': 'Il semble qu\'une personne portant le même nom existe déjà dans vos personnes enregistrées. Voulez-vous quand même enregistrer cette personne ?',
  'deletePerson.DYN.': 'Supprimer cette personne',
  'deletePerson.ask.DYN.': 'Êtes-vous sûr de vouloir supprimer cette personne ?',
  'deletePerson.valid.DYN.': 'La personne a été supprimée',
  'personModification.ask.DYN.': 'Êtes-vous sûr de vouloir modifier les données de cette personne ?',
  'personModification.valid.DYN.': 'Les données de la personne ont été modifiées',
  'noPayment': 'Aucun paiement',
  'selfie.desc': 'Une photo est requise pour la demande de visa, assurez-vous d\'être bien éclairé et de tenir votre téléphone stable pour éviter une image floue. Veillez également à ce que tous les détails de votre visage soient clairement visibles sur la photo.',
  'ZWEVISA.title': 'Visa',
  'EMBASSYPASS.title': 'Passeport d\'ambassade',
  'PREENROLL.title': 'Pré-inscription',
  'OK': 'Demande acceptée. Prêt pour l\'inscription',
  'DYN.NOK': 'Demande refusée',
  'WIP': 'Travail en cours',
  'menu.requests.DYN.': 'Demandes',
  'menu.createRequests.DYN.': 'Nouvelle demande',
  'request_state.SUBMITTED': 'Soumise',
  'request_state.CONFIRMED': 'Confirmée',
  'request_state.TREATED': 'Traitée',
  'request_state.TRANSFERRED': 'Transférée',
  'request_state.CANCELLED': 'Annulée',
  'request_state.REFUSED': 'Refusée',
  'request_state.UNUSABLE': 'Inutilisable',
  'request_state.NULL': 'Non payée',
  'request_state.NONE': '-- Aucun filtre --',
  'ask.disconnect': 'Êtes-vous sûr de vouloir vous déconnecter ?',
  'global.yes': 'Oui',
  'applicant.gender.male': 'Homme',
  'applicant.gender.female': 'Femme',
  'applicant.gender.other': 'Autre',
  'marital.status.single': 'Célibataire',
  'marital.status.married': 'Marié(e)',
  'marital.status.separated': 'Séparé(e)',
  'marital.status.divorced': 'Divorcé(e)',
  'marital.status.widowed': 'Veuf/Veuve',
  'marital.status.religiously_married': 'Marié(e) religieusement',
  'marital.status.married_according_to_custom': 'Marié(e) selon les coutumes',
  'marital.status.other': 'Autre',
  'marital.status.unknown': 'Inconnu',
  'request_state.PROPOSED': 'En attente de paiement',
  'request_state.PAID': 'Complet',
  'request_state.USED': 'Fermé',
  'request_state.DUPLICATED': 'Dupliqué',
  'request_state.REFUNDED': 'Remboursé',
  'request_state.EXPIRED': 'Refusé',
  'request_state.PAID_NOT_CONFIRMED': 'En attente de vérification',
  'request_state.DELAY_PAY_NOT_CONFIRMED': 'Payer plus tard - Non confirmé',
  'request_state.DELAY_PAY': 'Prêt à payer à l\'arrivée',
  'payment_status.DYN.0': 'En attente de paiement',
  'payment_status.DYN.1': 'Prêt pour l\'enregistrement',
  'payment_status.DYN.6': 'En attente de vérification',
  'payment_status.DYN.2.9': 'En attente de supervision',
  'payment_status.DYN.2.10': 'Supervisé',
  'payment_status.desc.DYN.2.10': 'La demande a été examinée par un superviseur et est prête à être traitée par l\'agent de contrôle des frontières.',
  'payment_status.desc.DYN.2.9': 'La demande est en attente de supervision. Un superviseur peut devoir examiner la demande avant qu\'elle ne puisse être traitée par l\'agent de contrôle des frontières.',
  'payment_status.DYN.7': 'En attente de correction',
  'payment_status.DYN.8': 'Payer plus tard - Non confirmé',
  'payment_status.DYN.9': 'Prêt à payer à l\'arrivée',
  'payment_status.DYN.9.entry': 'Prêt pour l\'enregistrement',
  'payment_status.DYN.9.exit': 'Prêt pour la sortie',
  'payment_status.DYN.2': 'Sortie effectuée',
  'payment_status.DYN.3': 'Dupliqué',
  'payment_status.DYN.4': 'Remboursé',
  'payment_status.DYN.5': 'Refusé',
  'payment_status.extension.DYN.5': 'Extension refusée',
  'payment_status.DYN.5.blacklisted': 'Refusé - Liste noire',
  'enrolReady': 'Demande acceptée. Prêt pour l\'inscription',
  'createPeople.success.DYN.': 'Personne enregistrée avec succès',
  'request.0': 'Demande acceptée. Prêt pour l\'inscription',
  'adminRequestResult.title.DYN.': 'Demande sélectionnée - {paymentID}',
  'form.paymentType': 'Type de paiement',
  'payment.type.online': 'En ligne',
  'payment.type.offline': 'Hors ligne',
  'request.state.DYN.': 'Statut de la demande',
  'form.birthDate': 'Date de naissance',
  'form.birthCountry': 'Pays de naissance',
  'form.placeOfBirth': 'Ville de naissance',
  'form.residenceAdress': 'Adresse de résidence',
  'form.maritalStatus': 'État civil',
  'form.dateOfExpiry': 'Date d\'expiration du passeport',
  'form.departureDate': 'Date de départ',
  'form.arrivalDate': 'Date d\'arrivée',
  'form.referencePreviousVisa': 'Référence du visa précédent',
  'form.passportNumber': 'Numéro de passeport',
  'form.hostName': 'Nom de l\'hôte',
  'form.purposeOfVisit': 'Raison de la visite',
  'form.previousConvictionsHome': 'Condamnations antérieures dans le pays d\'origine',
  'form.spouse.birthDay': 'Date de naissance du conjoint(e)',
  'form.spousePassportNumber': 'Numéro de passeport du conjoint(e)',
  'form.spousePlaceOfBirth': 'Lieu de naissance du conjoint(e)',
  'form.dependantFullName': 'Nom complet de la personne à charge',
  'form.dependantPassportNumber': 'Numéro de passeport de la personne à charge',
  'form.dependantPlaceOfBirth': 'Lieu de naissance de la personne à charge',
  'form.dependantBirthDay': 'Date de naissance de la personne à charge',
  'form.existingValidEntryReferenceOfficer': "Agent de référence d'entrée",
  'officer.unknown': 'Agent inconnu',
  'global.approve': 'Approuver',
  'global.refuse': 'Refuser',
  'global.suspend': 'Demander une correction',
  'personal.data': 'Données personnelles',
  'contact.data': 'Données de contact',
  'applicant.status': 'Statut du demandeur',
  'company.data': 'Informations de l\'entreprise',
  'divers.data.DYN.': 'Détails du voyage',
  'dependant.data': 'Données des personnes à charge',
  'spouse.data': 'Données du conjoint(e)',
  'payment.refuse.ask.extension.DYN.': 'Voulez-vous vraiment <b>REFUSER</b> cette demande d\'extension ?',
  'payment.approve.ask.extension.DYN.': 'Voulez-vous vraiment <b>APPROUVER</b> cette demande d\'extension ?',
  'payment.review.approve.ask.DYN.': 'Voulez-vous vraiment examiner cette demande de document comme <b>RECOMMANDÉE</b> ?',
  'payment.review.approve.success.extension.DYN.': 'Cette demande d\'extension a été examinée comme <b>RECOMMANDÉE</b>.',
  'payment.review.refuse.ask.DYN.': 'Voulez-vous vraiment examiner cette demande de document comme <b>NON RECOMMANDÉE</b> ?',
  'payment.review.refuse.ask.extension.DYN.': 'Voulez-vous vraiment examiner cette demande d\'extension comme <b>NON RECOMMANDÉE</b> ?',
  'payment.review.refuse.success.extension.DYN.': 'Cette demande d\'extension a été examinée comme <b>NON RECOMMANDÉE</b>.',
  'payment.review.approve.extension.ask.DYN.': 'Voulez-vous vraiment <b>APPROUVER</b> cette demande d\'extension ?',
  'payment.validate.ask.DYN.': 'Voulez-vous vraiment <b>APPROUVER</b> cette demande de document ?',
  'payment.validate.extension.ask.DYN.': 'Voulez-vous vraiment <b>APPROUVER</b> cette demande d\'extension ?',
  'payment.refuse.success.extension.DYN.': 'Demande d\'extension <b>REFUSÉE</b> avec succès.',
  'payment.approve.success.extension.DYN.': 'Demande d\'extension <b>APPROUVÉE</b> avec succès.',
  'error.payment.suspend.error.DYN.': 'Une erreur est survenue lors de la suspension de la demande de document.',
  'error.payment.validate.error.DYN.': 'Une erreur est survenue lors de l\'approbation de la demande de document.',
  'global.no': 'Non',
  'global.Yes': 'Oui',
  'global.No': 'Non',
  'photo.entryContry': 'Photo du pays d\'entrée',
  'documents': 'Documents',
  'data.biographic': 'Page biographique du passeport',
  'residence.proof': 'Preuve de résidence',
  'address.destination': 'Adresse de destination',
  'previous.visa': 'Visa précédent',
  'invite.letter': 'Lettre d\'invitation',
  'hostInvitation.letter': 'Lettre d\'invitation de l\'hôte',
  'proof.residenceHost': 'Preuve de résidence de l\'hôte',
  'hostResidential.status': 'Statut de résidence de l\'hôte',
  'reasonOfVisit.proof': 'Preuve de la raison de la visite dans le pays de destination',
  'inviteBusiness.letter': 'Lettre commerciale de l\'entreprise invitante',
  'business.profile': 'Profil professionnel du voyageur',
  'application.letter': 'Lettre de demande de visa',
  'acceptanceFromScool.letter': 'Lettre de confirmation',
  'date.creation': 'Date de création',
  'document.Passport': 'Passeport',
  'completeName': 'Nom complet',
  'price': 'Prix',
  'global.retry': 'Réessayer',
  'err.loginWeak': 'Problème de connexion, veuillez réessayer',
  'URGENTPASS.title': 'Passeport urgent',
  'refusalReason': 'Raison du refus',
  'error.payment.noRefuseReason': 'Veuillez saisir un message.',
  'error.payment.noSuspendReason': 'Veuillez saisir une raison de suspension. Cette raison sera envoyée au client.',
  'refusal.desc.DYN.': 'Cette demande de document a été refusée.',
  'refusal.desc.extension.DYN.': 'Cette demande d\'extension a été refusée.',
  'approval.desc.DYN.': 'Cette demande de document a été approuvée.',
  'approval.desc.extension.DYN.': 'Cette demande d\'extension a été approuvée.',
  'review.approval.desc.DYN.': 'Cette demande de document répond aux exigences.',
  'review.approval.desc.extension.DYN.': 'Cette demande d\'extension répond aux exigences.',
  'review.refusal.desc.DYN.': 'Cette demande de document ne répond pas aux exigences.',
  'review.refusal.desc.extension.DYN.': 'Cette demande d\'extension ne répond pas aux exigences.',
  'err.getUsers: client.extended.notActiveToken': 'Votre session a expiré. Veuillez vous reconnecter.',
  'VISA_DOUBLE.title': 'Visa double entrée',
  'VISA_KAZA.title': 'Visa Kaza',
  'history': 'Historique',
  'menu.people.DYN.': 'Personnes enregistrées',
  'DYN.XBA': 'African Development Bank',
  'DYN.AGO': 'Angola',
  'DYN.ABW': 'Aruba',
  'DYN.ATG': 'Antigua & Barbuda',
  'DYN.BHS': 'Bahamas',
  'DYN.BRB': 'Barbade',
  'DYN.BLZ': 'Belize',
  'DYN.BWA': 'Botswana',
  'DYN.CYM': 'Îles Caïmans',
  'DYN.CYP': 'Chypre',
  'DYN.FJI': 'Fidji',
  'DYN.COD': 'République démocratique du Congo',
  'DYN.GHA': 'Ghana',
  'DYN.GRD': 'Grenade',
  'DYN.HKG': 'Région administrative spéciale de Hong Kong (Chine)',
  'DYN.KEN': 'Kenya',
  'DYN.KIR': 'Kiribati',
  'DYN.JAM': 'Jamaïque',
  'DYN.LDW': 'Îles Sous-le-Vent',
  'DYN.LSO': 'Lesotho',
  'DYN.MDG': 'Madagascar',
  'DYN.MWI': 'Malawi',
  'DYN.MYS': 'Malaisie',
  'DYN.MDV': 'Maldives',
  'DYN.MLT': 'Malte',
  'DYN.MUS': 'Maurice',
  'DYN.MSR': 'Montserrat',
  'DYN.MOZ': 'Mozambique',
  'DYN.NAM': 'Namibie',
  'DYN.NRU': 'Nauru',
  'DYN.LCA': 'Sainte-Lucie',
  'DYN.VCT': 'Saint-Vincent-et-les-Grenadines',
  'DYN.WSM': 'Samoa occidentales',
  'DYN.SYC': 'Seychelles',
  'DYN.SGP': 'Singapour',
  'DYN.SLB': 'Îles Salomon',
  'DYN.ZAF': 'Afrique du Sud',
  'DYN.KNA': 'Saint-Christophe-et-Niévès',
  'DYN.SWZ': 'Swaziland',
  'DYN.TON': 'Tonga',
  'DYN.TTO': 'Trinité-et-Tobago',
  'DYN.TCA': 'Îles Turques-et-Caïques',
  'DYN.TUV': 'Tuvalu',
  'DYN.UGA': 'Ouganda',
  'DYN.TZA': 'République-Unie de Tanzanie',
  'DYN.VUT': 'Vanuatu',
  'DYN.VAT': 'Vatican',
  'DYN.VEN': 'Venezuela (République bolivarienne du)',
  'DYN.USA': 'États-Unis d\'Amérique',
  'DYN.URY': 'Uruguay',
  'DYN.UZB': 'Ouzbékistan',
  'DYN.UKR': 'Ukraine',
  'DYN.ARE': 'Émirats arabes unis',
  'DYN.GBR': 'Royaume-Uni de Grande-Bretagne et d\'Irlande du Nord',
  'DYN.TUR': 'Turquie',
  'DYN.TKM': 'Turkménistan',
  'DYN.SWE': 'Suède',
  'DYN.CHE': 'Suisse',
  'DYN.TJK': 'Tadjikistan',
  'DYN.KAZ': 'Kazakhstan',
  'DYN.SUR': 'Suriname',
  'DYN.ESP': 'Espagne',
  'DYN.SVK': 'Slovaquie',
  'DYN.SVN': 'Slovénie',
  'DYN.SEN': 'Sénégal',
  'DYN.SRB': 'Serbie',
  'DYN.SMR': 'Saint-Marin',
  'DYN.STP': 'Sao Tomé-et-Principe',
  'DYN.NLD': 'Pays-Bas',
  'DYN.NCL': 'Nouvelle-Calédonie',
  'DYN.NZL': 'Nouvelle-Zélande',
  'DYN.NIC': 'Nicaragua',
  'DYN.MEX': 'Mexique',
  'DYN.FSM': 'Micronésie, États fédérés de',
  'DYN.MDA': 'Moldavie',
  'DYN.MCO': 'Monaco',
  'DYN.MHL': 'Îles Marshall',
  'DYN.LVA': 'Lettonie',
  'DYN.NFK': 'Île Norfolk',
  'DYN.MNP': 'Îles Mariannes du Nord',
  'DYN.NOR': 'Norvège',
  'DYN.PLW': 'Palaos',
  'DYN.PSE': 'Palestine',
  'DYN.PAN': 'Panama',
  'DYN.PNG': 'Papouasie-Nouvelle-Guinée',
  'DYN.PRY': 'Paraguay',
  'DYN.PER': 'Pérou',
  'DYN.POL': 'Pologne',
  'DYN.PRT': 'Portugal',
  'DYN.PRI': 'Porto Rico',
  'DYN.REU': 'Réunion',
  'DYN.ROU': 'Roumanie',
  'DYN.RUS': 'Fédération de Russie',
  'DYN.RWA': 'Rwanda',
  'DYN.LIE': 'Liechtenstein',
  'DYN.LTU': 'Lituanie',
  'DYN.LUX': 'Luxembourg',
  'DYN.MAC': 'Région administrative spéciale de Macao (Chine)',
  'DYN.JPN': 'Japon',
  'DYN.KWT': 'Koweït',
  'DYN.KGZ': 'Kirghizistan',
  'DYN.KOR': 'Corée du Sud',
  'DYN.GUY': 'Guyane',
  'DYN.HTI': 'Haïti',
  'DYN.HND': 'Honduras',
  'DYN.IRL': 'Irlande',
  'DYN.ISR': 'Israël',
  'DYN.ITA': 'Italie',
  'DYN.HUN': 'Hongrie',
  'DYN.ISL': 'Islande',
  'DYN.IND': 'Inde',
  'DYN.IDN': 'Indonésie',
  'DYN.IRN': 'Iran',
  'DYN.GUM': 'Guam',
  'DYN.GTM': 'Guatemala',
  'DYN.GIB': 'Gibraltar',
  'DYN.GRC': 'Grèce',
  'DYN.GEO': 'Géorgie',
  'DYN.DEU': 'Allemagne',
  'DYN.DNK': 'Danemark',
  'DYN.EST': 'Estonie',
  'DYN.ETH': 'Éthiopie',
  'DYN.FIN': 'Finlande',
  'DYN.FRA': 'France',
  'DYN.GUF': 'Guyane française',
  'DYN.PYF': 'Polynésie française',
  'DYN.ATF': 'Terres australes et antarctiques françaises',
  'DYN.CZE': 'République tchèque',
  'DYN.COM': 'Comores',
  'DYN.DOM': 'République dominicaine',
  'DYN.ECU': 'Équateur',
  'DYN.EGY': 'Égypte',
  'DYN.SLV': 'Salvador',
  'DYN.GNQ': 'Guinée équatoriale',
  'DYN.CHL': 'Chili',
  'DYN.CHN': 'Chine',
  'DYN.CHN_NT': 'Chine (non touristique)',
  'DYN.COK': 'Îles Cook',
  'DYN.CRI': 'Costa Rica',
  'DYN.HRV': 'Croatie',
  'DYN.CUB': 'Cuba',
  'DYN.BDI': 'Burundi',
  'DYN.CAN': 'Canada',
  'DYN.CPV': 'Cap-Vert',
  'DYN.BRA': 'Brésil',
  'DYN.VGB': 'Îles Vierges britanniques',
  'DYN.BRN': 'Brunéi Darussalam',
  'DYN.BGR': 'Bulgarie',
  'DYN.BMU': 'Bermudes',
  'DYN.BTN': 'Bhoutan',
  'DYN.BIH': 'Bosnie-Herzégovine',
  'DYN.BLR': 'Bélarus',
  'DYN.BEL': 'Belgique',
  'DYN.BHR': 'Bahreïn',
  'DYN.ARG': 'Argentine',
  'DYN.ARM': 'Arménie',
  'DYN.AUS': 'Australie',
  'DYN.AUT': 'Autriche',
  'DYN.AZE': 'Azerbaïdjan',
  'DYN.ALB': 'Albanie',
  'DYN.DZA': 'Algérie',
  'DYN.AIA': 'Anguilla',
  'DYN.BGD': 'Bangladesh',
  'DYN.BEN': 'Bénin',
  'DYN.AFG': 'Afghanistan',
  'DYN.BOL': 'Bolivie',
  'DYN.BFA': 'Burkina Faso',
  'DYN.KHM': 'Cambodge',
  'DYN.CMR': 'Cameroun',
  'DYN.CIV': 'Côte d\'Ivoire',
  'DYN.CAF': 'République Centrafricaine',
  'DYN.TCD': 'Tchad',
  'DYN.COL': 'Colombie',
  'DYN.ERI': 'Érythrée',
  'DYN.COG': 'Congo-Brazzaville',
  'DYN.PRK': 'République populaire démocratique de Corée',
  'DYN.GAB': 'Gabon',
  'DYN.GMB': 'Gambie',
  'DYN.DJI': 'Djibouti',
  'DYN.GIN': 'Guinée',
  'DYN.GNB': 'Guinée-Bissau',
  'DYN.IRQ': 'Irak',
  'DYN.KOS': 'Kosovo',
  'DYN.LAO': 'République démocratique populaire lao',
  'DYN.JOR': 'Jordanie',
  'DYN.LBR': 'Liberia',
  'DYN.LBY': 'Jamahiriya arabe libyenne',
  'DYN.MLI': 'Mali',
  'DYN.QAT': 'Qatar',
  'DYN.REF': 'Réfugié',
  'DYN.PHL': 'Philippines',
  'DYN.OMN': 'Oman',
  'DYN.PAK': 'Pakistan',
  'DYN.LBN': 'Liban',
  'DYN.MRT': 'Mauritanie',
  'DYN.MNG': 'Mongolie',
  'DYN.MNE': 'Monténégro',
  'DYN.NER': 'Niger',
  'DYN.NGA': 'Nigéria',
  'DYN.MMR': 'Myanmar',
  'DYN.MAR': 'Maroc',
  'DYN.NPL': 'Népal',
  'DYN.SAU': 'Arabie saoudite',
  'DYN.SLE': 'Sierra Leone',
  'DYN.SOM': 'Somalie',
  'DYN.LKA': 'Sri Lanka',
  'DYN.SSD': 'Soudan du Sud',
  'DYN.SDN': 'Soudan',
  'DYN.THA': 'Thaïlande',
  'DYN.MKD': 'Ex-République yougoslave de Macédoine',
  'DYN.TGO': 'Togo',
  'DYN.SYR': 'République arabe syrienne',
  'DYN.TWN': 'Taïwan',
  'DYN.TUN': 'Tunisie',
  'DYN.VNM': 'Viet Nam',
  'DYN.YEM': 'Yémen',
  'DYN.TLS': 'Timor-Leste',
  'DYN.AND': 'Andorre',
  'DYN.VIR': 'Îles Vierges (États-Unis)',
  'DYN.XKX': 'Kosovo',
  'DYN.ZWE': 'Zimbabwe',
  'DYN.ZMB': 'Zambie',
  'DYN.ASM': 'Samoa américaines',
  'DYN.DMA': 'Dominique',
  'DYN.XXA': 'Apatride',
  'DYN.XXB': 'Réfugié (convention de Genève)',
  'DYN.XXC': 'Réfugié (Autre)',
  'DYN.UNA': 'Agence des Nations Unies',
  'DYN.UNO': 'Organisation des Nations Unies',
  'DYN.role.0': 'Client',
  'DYN.role.1': 'Employé',
  'DYN.role.2': 'Consommateur Orbis',
  'DYN.role.3': 'Administrateur',
  'DYN.role.4': 'Registre des partenaires',
  'DYN.role.5': 'Kiosque',
  'DYN.role.6': 'Moniteur Externe',
  'err.Occupation.pattern': 'L\'occupation doit être dans un format correct',
  'err.PreviousConvictionsHome.pattern': 'Les condamnations antérieures dans le pays d\'origine doivent être dans un format correct',
  'err.PlaceOfBirth.pattern': 'Le lieu de naissance doit avoir un format correct',
  'document.type.DYN.': 'Type de demande',
  'dependantIndex': 'Dépendant {index}',
  'form.spouseFullName': 'Nom complet du conjoint',
  'qrDesc.valid': 'Présentez ce code QR au point de contrôle des visas lors de l\'entrée ou de la sortie du pays. Vous ne pouvez pas voyager sans un code QR valide.',
  'qrDesc.invalid': 'Cette demande de visa est actuellement invalide. Vous ne pouvez pas voyager sans une demande de visa valide. Veuillez contacter le bureau des visas pour plus d\'informations.',
  'err.pay': 'Une erreur est survenue pendant le paiement. Réessayez.',
  'payment.noEvents': 'Cette demande ne contient actuellement aucun traitement lié aux voyages (utilisations de la demande).',
  'global.cancel': 'Annuler',
  'global.loading': 'Chargement',
  'end.suspend': 'Terminer la correction',
  'trips.title': 'Suivre les demandes',
  'trips.desc': 'Demande(s)',
  'BatchId': 'Référence de la demande',
  'newBatchId.desc': 'Veuillez entrer un nom pour ce voyage.',
  'personLinkType.DYN.0': 'Inconnu',
  'personLinkType.DYN.1': 'Enfant',
  'personLinkType.DYN.2': 'Parent',
  'personLinkType.DYN.3': 'Conjoint',
  'personLinkType.DYN.4': 'Autre',
  'personLinkType.DYN.5': 'Vous-même',
  'batchIds.desc': 'Demandes liées à la référence {trip} :',
  'trip.name': 'Référence de la demande',
  'visaIntro.validFrom': 'Date de début',
  'visaIntro.validUntil': 'Date d\'expiration',
  'visaIntro.usageCount': 'Utilisation(s) autorisée(s)',
  'client.extended.passportNumberAlreadyExists': 'Ce numéro de passeport est déjà utilisé. Veuillez en saisir un autre.',
  'client.extended.alreadyDecided': 'Cette demande de visa a déjà été examinée par vous. Vous ne pouvez pas l\'examiner à nouveau.',
  'client.extended.outOfUsage': 'Cette demande est <b>hors de sa période de validité</b>',
  'global.review': 'Vérifier',
  'ask.review.extension.0': 'Sélectionnez votre évaluation pour cette demande d\'extension.',
  'error.review.noChoice': 'Veuillez sélectionner un état d\'examen pour continuer.',
  'all.reviews': 'Tous les avis sur cette demande de visa',
  'all.reviews.extension': 'Tous les avis sur cette demande d\'extension',
  'validate.desc': 'Cette demande de visa a été approuvée le {date} par l\'utilisateur',
  'validate.extension.desc': 'Cette demande d\'extension a été approuvée le {date} par l\'utilisateur',
  'refusal.review.desc': 'Cette demande de visa a été refusée le {date} par l\'utilisateur',
  'refusal.review.extension.desc': 'Cette demande d\'extension a été refusée le {date} par l\'utilisateur',
  'refusal.review.desc.blacklisted': 'Cette demande de visa a été refusée et mise sur liste noire le {date} par l\'utilisateur',
  'approve.text': 'Cette demande a été approuvée.',
  'pending.review.desc': 'Une correction de cette demande de visa a été demandée au demandeur le {date} par l\'utilisateur',
  'global.reason': 'Raison',
  'pending.desc': 'Cette demande de visa est en attente de correction par le client.',
  'success.onArrival': 'Votre demande a été soumise avec succès. Vous pouvez voir le code QR de cette demande en haut. Présentez ce code QR au point de contrôle des visas lors de l\'entrée/sortie du pays. Vous ne pouvez pas voyager sans une demande de visa valide.',
  'successRequest.title': 'Demande soumise avec succès',
  'amountDue': 'Prix : ',
  'amountDue.total.now': 'Total dû maintenant : ',
  'amountDue.total.later': 'Total dû au guichet : ',
  'noPrint.mobile': 'L\'impression de page n\'est pas prise en charge sur les appareils mobiles',
  'onArrival.reset': 'Commencer un nouveau processus',
  'onArrival.reset.ask': 'Voulez-vous vraiment commencer un nouveau processus?',
  'stillHere': 'Êtes-vous toujours là ? Ce processus se réinitialisera dans 20 secondes.',
  'print.request': 'Imprimer la demande',
  'EXPIRED.globalExplain': 'Cette demande a été refusée. Elle ne respecte pas nos normes.',
  'payment_status.desc.DYN.7': 'Cette demande de document est en attente de correction par le client.',
  'payment_status.DYN.6.review': 'En attente de vérification - {reviewCount}/2',
  'payment_status.extension.DYN.6': 'En attente de vérification',
  'payment_status.extension.DYN.6.review': 'En attente de vérification - {reviewCount}/1',
  'payment_status.desc.DYN.6.review': 'Cette demande de document est en attente de vérification. Elle a déjà été vérifiée {reviewCount} fois.',
  'payment_status.DYN.6.finalReview': 'En attente de la vérification finale',
  'payment_status.extension.DYN.6.finalReview': 'En attente de la vérification finale',
  'payment_status.desc.DYN.6.finalReview': 'Cette demande de document a été vérifiée et est actuellement en attente de la vérification finale.',
  'payment_status.desc.DYN.0': 'Cette demande est en attente de validation de paiement auprès de l\'institution de paiement. Si le paiement n\'a pas encore été effectué, il peut être complété maintenant.',
  'payment_status.desc.DYN.5': 'Cette demande de document a été refusée.',
  'payment_status.desc.extension.DYN.5': 'Cette demande d\'extension a été refusée.',
  'payment_status.desc.DYN.5.blacklisted': 'Cette demande de document a été refusée et la personne a été mise sur liste noire.',
  'payment_status.desc.DYN.5.checkIn': 'Cette demande a été refusée lors de l\'enregistrement au guichet.',
  'payment_status.desc.DYN.5.checkIn.reason': 'Cette demande a été refusée lors de l\'enregistrement au guichet. <p><b>Raison</b> : <br/> {reason}</p>',
  'payment_status.DYN.5.checkIn': 'Refusé à l\'enregistrement',
  'payment_status.desc.DYN.5.checkOut': 'Cette demande a été refusée lors du départ au guichet.',
  'payment_status.DYN.5.checkOut': 'Refusé à la sortie',
  'payment_status.desc.DYN.9': 'Cette demande de document est prête à être payée au guichet. L\'enregistrement peut être effectué après le paiement.',
  'payment_status.desc.DYN.9.entry': 'Cette demande est prête à être enregistrée au guichet.',
  'payment_status.desc.DYN.9.exit': 'Cette demande est prête à être vérifiée pour la sortie et nécessite un paiement pour le laisser-passer frontalier délivré au guichet.',
  'payment_status.DYN.2.out': 'Prêt à sortir',
  'payment_status.DYN.2.outFinish': 'Fermé',
  'payment_status.DYN.2.closed': 'Fermé',
  'payment_status.desc.DYN.2.closed': 'Cette demande a été clôturée.',
  'payment_status.desc.DYN.2.zweexit': 'Cette demande est prête à être vérifiée pour la sortie au guichet.',
  'payment_status.DYN.2.entryFinish': 'Enregistré',
  'payment_status.DYN.2.in': 'Prêt à entrer',
  'payment_status.desc.DYN.2.out': 'Cette demande a été enregistrée à l\'entrée. L\'étape suivante est la sortie au guichet.',
  'payment_status.desc.DYN.2.outFinish': 'Cette demande a été validée à la sortie. Le client peut maintenant voyager.',
  'payment_status.desc.DYN.2.entryFinish': 'Cette demande a été validée à l\'entrée. Le client peut maintenant entrer dans le pays.',
  'payment_status.desc.DYN.2.in': 'Cette demande est en attente d\'enregistrement au guichet.',
  'ask.isArrivalPaid': 'Le paiement suivant doit être effectué maintenant dans l\'une des devises suivantes :',
  'ask.isArrivalPaid.exit': 'Le laissez-passer frontalier doit être payé maintenant dans l\'une des devises suivantes :',
  'ask.isArrivalPaid.confirm': 'Confirmez-vous que le paiement a été effectué ? Si vous confirmez, veuillez entrer la référence de paiement, le mode de paiement et la devise utilisée. Vous pouvez également modifier la date maximale de séjour (vous ne pouvez que la réduire).',
  'ask.isArrivalPaid.confirm.exit': 'Confirmez-vous que le paiement a été effectué ? Si vous confirmez, veuillez entrer la référence de paiement et la devise utilisée.',
  'ask.checkoutExpired.confirm': 'Confirmez-vous que le paiement a été effectué ? Si vous confirmez, veuillez entrer la référence de paiement et la devise utilisée.',
  'no_trips': 'Vous n\'avez aucun voyage.',
  'err.canActivate': 'Une erreur s\'est produite',
  'form.passportNumber.dateOfIssue': 'Date de délivrance du passeport',
  'form.passportNumber.dateOfExpiry': 'Date d\'expiration du passeport',
  'form.passportNumber.placeOfIssue': 'Lieu de délivrance du passeport',
  'nextOfKin.data': 'Contact d\'urgence / Proche',
  'form.otherLinkType': 'Précisez le lien de parenté',
  'camera.problem.manual': 'Vous êtes sur le point de valider cette demande de visa sans photo du client. Voulez-vous vraiment continuer ?',
  'camera.problem.button': 'Problème avec la caméra ?',
  'global.noFilter': '--Pas de filtre--',
  'zweentry': 'Entrée sans visa',
  'zweentry.title': 'Entrée sans visa',
  'free.charge': 'Gratuit',
  'camera.init.error': 'Une erreur est survenue lors de l\'initialisation de la caméra. Voulez-vous valider cette demande sans photo du client ?',
  'error.payment.noPaymentReference': 'Veuillez entrer une référence de paiement, un mode de paiement et la devise utilisée.',
  'paymentReference.ask': 'Référence du paiement',
  'paymentReference.askExpired': 'Référence du paiement pour la surtaxe de dépassement de séjour',
  'session.expired': 'Votre session a expiré. Veuillez vous reconnecter.',
  'error.approveRefuse.DYN.': 'Une erreur s\'est produite lors de l\'approbation ou du refus de la demande de document.',
  'phone.pattern': ' (ex : +263771234567)',
  'global.receipt.id': 'ID de la demande : {paymentId}',
  'ask.place.updatePermissions': 'Voulez-vous vraiment mettre à jour les autorisations de ce lieu?',
  'place.updatePermissions.success': 'Les autorisations du lieu ont été mises à jour avec succès.',
  'err.place.updatePermissions': 'Une erreur s\'est produite lors de la mise à jour des autorisations du lieu.',
  'global.urgent': 'Urgent',
  'form.usageAfter': 'Valide à partir de',
  'form.usageUntil': 'Valide jusqu\'à',
  'form.localUsageUntil': 'Date maximale de fin de séjour',
  'form.timeslot': 'Créneaux horaires',
  'internalReference': 'Référence HQ',
  'payment_status.DYN.6.0': 'En attente de vérification 0/2',
  'payment_status.DYN.6.1': 'En attente de vérification 1/2',
  'payment_status.DYN.6.2': 'En attente de la vérification finale',
  'payment_status.DYN.8.0': 'Payer plus tard - Non confirmé',
  'payment_status.DYN.2.0': 'Enregistré',
  'payment_status.DYN.2.4': 'Prêt à sortir',
  'payment_status.DYN.2.5': 'Fermé',
  'payment_status.DYN.2.6': 'Refusé à l\'enregistrement',
  'payment_status.DYN.2.7': 'Refusé à la sortie',
  'payment_status.DYN.2.8': 'Fermé',
  'payment_status.extension.DYN.6.0': 'En attente de vérification 0/1',
  'payment_status.extension.DYN.6.2': 'En attente de la vérification finale',
  'payment_status.extension.DYN.7': 'En attente de correction',
  'payment_status.extension.DYN.9': 'Prolongation validée',
  'payment_status.extension.DYN.0': 'Paiement en attente',
  'internalReference.create': 'Ajouter une référence HQ',
  'internalReference.edit': 'Modifier la référence HQ',
  'timeslot.set': 'Définir un créneau',
  'timeslot.setNew': 'Définir un nouveau créneau',
  'internalReference.ask.edit': 'Veuillez entrer la nouvelle référence HQ.',
  'internalReference.ask.create': 'Veuillez entrer la référence HQ.',
  'internalReference.done.create': 'La référence HQ a été ajoutée avec succès.',
  'internalReference.done.edit': 'La référence HQ a été modifiée avec succès.',
  'error.internalReference': 'Une erreur s\'est produite lors de l\'ajout ou de la modification de la référence HQ.',
  'error.paymentUntil.expired': 'Cette demande est au-delà de sa période de validité. Vous pouvez procéder au processus de sortie pour le client; cependant, veuillez noter qu\'une surtaxe de 100 USD est requise en raison de l\'état expiré de la demande de visa. Le paiement doit être effectué immédiatement dans l\'une des devises suivantes :',
  'internalReference.desc': 'Ajouter une référence HQ à cette demande (par exemple, 140_2024).',
  'titlePrint': 'Demande de visa </br> <b>{paymentID}</b>',
  'title.visaReference': 'Demande liée',
  'titlePrint.extension': 'Demande d\'extension </br> <b>{paymentID}</b>',
  'globalStatus.valid': 'Valide',
  'PENDING.globalExplain': 'Cette demande est en attente de correction. Veuillez vérifier les informations et les corriger.',
  'PAID_NOT_CONFIRMED.globalExplain': 'Cette demande est en attente de confirmation par nos services.',
  'PROPOSED.globalExplain': 'Cette demande est en attente de paiement. Si vous n\'avez pas encore validé le paiement, vous pouvez le faire maintenant.',
  'usageValidityConditions': 'Les autorités de l\'immigration se réservent le droit d\'annuler le visa à tout moment si le titulaire du visa ne respecte pas les conditions associées.',
  'afterWithoutUntil': 'Vous êtes autorisé à entrer à partir du {dateAfter} jusqu\'au {deadlineDate}.',
  'afterWithoutUntilAndMillis': 'Vous êtes autorisé à voyager à partir du {dateAfter}.',
  'afterAndUntil': 'Vous êtes autorisé à voyager du {dateAfter} jusqu\'au {dateUntil}.',
  'photo.current': 'Photo actuelle',
  'photo.scanned': 'Photo scannée à partir du passeport',
  'createdAt': 'Date de création',
  'all.infos': 'Informations sur cette demande',
  'afterRefused': 'Dates de voyage déclarées : {dateAfter}.',
  'DYN.paymentError.desc.success': `<p>Votre commande a été enregistrée avec succès. Si une partie de cette demande nécessite une approbation de nos équipes, vous serez informé une fois ce processus terminé. Sinon, sachez que nous avons reçu votre demande.</p>
  <p><b>Merci d'avoir choisi nos services.</b></p>`,
  'successPayment.kiosk': '<p>Votre demande a été enregistrée avec succès. Vous pouvez maintenant vous rendre au guichet pour vous enregistrer.</p><p><b>Merci d\'avoir choisi nos services.</b></p>',
  'sinceOneWeek': 'Veuillez noter que cette demande de document est en attente de vérification depuis plus d\'une semaine.',
  'client.extended.onlyAdminDecide': 'Cette demande de visa a déjà été vérifiée par un travailleur du même niveau d\'ancienneté que vous. Vous ne pouvez pas la vérifier à nouveau.',
  'error.paymentUntil.before': 'La date est trop tôt. Cette demande sera valide à partir du {dateAfter}.',
  'applicant.gender.FEMALE': 'Féminin',
  'applicant.gender.MALE': 'Masculin',
  'entry.consume': 'Arrivées',
  'exit.consume': 'Départs',
  'scan.noConsumeMode': 'En tant qu\'officier frontalier, vous êtes chargé de gérer les entrées et les sorties. Veuillez sélectionner l\'option correspondant à votre tâche actuelle : traitement des arrivées ou gestion des départs.',
  'scan.kiosk': 'Aucun enregistrement en statut "Prêt à entrer" pour une entrée n\'a été trouvé pour cette personne. Veuillez demander à la personne de créer une nouvelle demande au kiosque.',
  'scan.office': 'Aucun enregistrement en statut "Prêt à entrer" pour une entrée n\'a été trouvé pour cette personne. La nationalité de cette personne est de catégorie C, ce qui signifie qu\'elle a besoin d\'un visa. Veuillez escorter cette personne au bureau pour obtenir un visa urgent ou pour lui refuser l\'entrée.',
  'scan.noVisaFound': 'Aucun enregistrement en statut "Prêt à sortir" pour une sortie n\'a été trouvé pour cette personne. Voulez-vous en créer un prêt à sortir ?',
  'zweexit': 'Sortie sans visa',
  'err.scanPassport': 'Une erreur est survenue lors de la numérisation du passeport. Veuillez vérifier qu\'il est correctement inséré et réessayer. Si le problème persiste, redémarrez l\'application ou contactez le support.',
  'exit.register': 'Enregistrer une sortie',
  'entry.register': 'Enregistrer une entrée',
  'exit.create': 'Créer une sortie sans visa',
  'exit.ask': 'Êtes-vous sûr de vouloir enregistrer une sortie sans visa pour cette personne ?',
  'border': 'Officier à la frontière',
  'global.signout': 'Déconnexion',
  'search.manually': 'Rechercher une demande',
  'scan.applicationQr': 'Scanner le code QR de la demande',
  'err.client.extended.maxUsageCountReached': 'Le nombre maximum d\'utilisations pour cette demande a été atteint.',
  'form.firstName.scanned': 'Prénom(s) scanné(s)',
  'form.lastName.scanned': 'Nom de famille scanné',
  'form.documentNumber.scanned': 'Numéro de passeport scanné',
  'form.gender.scanned': 'Genre scanné',
  'form.birthDate.scanned': 'Date de naissance scannée',
  'form.nationality': 'Nationalité',
  'form.nationality.scanned': 'Nationalité scannée',
  'application.data': 'Données de la demande',
  'no.passportPhoto': 'Pas de photo',
  'overstay': 'Dépassement de séjour',
  'method.payment': 'Méthode de paiement',
  'review.desc': 'Approuver/Refuser',
  'approval.usageUntil.DYN.': 'Changer la date d\'expiration (optionnel)',
  'scanned.list': 'Liste des demandes trouvées',
  'scanned.recommended': 'Recommandé',
  'scanned.entriesUsed': 'entrées utilisées',
  'scanned.paid': 'Payé',
  'visa.blacklist': 'Cette demande de visa a été mise sur liste noire. La personne n\'est pas autorisée à entrer dans le pays.',
  'scan.noEntryFound': 'Aucun enregistrement en statut "Prêt à entrer" pour une entrée n\'a été trouvé pour cette personne. Voulez-vous en créer un prêt à entrer ?',
  'global.syncing': 'Synchronisation...',
  'payment.consume.error.DYN.': 'Une erreur s\'est produite lors du traitement de la demande.',
  'tooltip.changeTimeslot': 'Modifier le créneau horaire',
  'tooltip.transit': 'Cochez cette case pour gérer le transit en tant qu\'agent frontalier.',
  'tooltip.Qr': 'Vous pouvez scanner directement le code QR associé à une demande pour obtenir des informations détaillées sur cette demande.',
  'tooltip.arrivals': 'Cochez cette case pour gérer les arrivées en tant qu\'officier frontalier.',
  'tooltip.departures': 'Cochez cette case pour gérer les départs en tant qu\'officier frontalier.',
  'tooltip.searchManually': 'Recherchez une demande spécifique en utilisant divers critères.',
  'tooltip.signout': 'Déconnectez-vous de l\'application.',
  'tooltip.my_account': 'Accédez aux paramètres de votre compte.',
  'tooltip.dashboard': 'Accédez au tableau de bord.',
  'tooltip.createRequests': 'Créer une nouvelle demande.',
  'tooltip.trips': 'Consultez le statut de vos demandes et imprimez le document lié si approuvé.',
  'tooltip.people': 'Gérez les personnes associées à votre compte.',
  'tooltip.users': 'Gérez les utilisateurs de l\'application.',
  'tooltip.requests': 'Gérez les demandes de l\'application.',
  'tooltip.places': 'Gérez les lieux de l\'application.',
  'tooltip.role': 'Votre rôle et nom dans l\'application.',
  'tooltip.exitRegister': 'Enregistrez manuellement une sortie sans visa pour une personne.',
  'tooltip.entryRegister': 'Enregistrez manuellement une entrée sans visa pour une personne.',
  'tooltip.support': 'Contactez le support pour toute assistance.',
  'tooltip.chooseLang': 'Changer la langue de l\'application. Actuellement, seule l\'anglais est disponible.',
  'tooltip.changePassword': 'Changer votre mot de passe.',
  'tooltip.internalReferenceNoFilter': 'Cliquez sur une référence interne, si disponible, pour être redirigé vers la référence liée.',
  'tooltip.state': 'Filtrer les demandes en fonction de leur statut.',
  'tooltip.tableBatchId': 'La référence de la demande associée à la demande',
  'tooltip.tableState': 'Le statut de la demande',
  'tooltip.tableUsageAfter': 'La date de début de la demande',
  'tooltip.tableUsageUntilTitle': 'Trier les demandes par date d\'expiration.',
  'tooltip.tableUsageUntil': 'La date d\'expiration de la demande',
  'tooltip.tableIdTitle': 'Trier les demandes en fonction de l\'ID.',
  'tooltip.tableId': 'L\'ID de la demande',
  'tooltip.history': 'L\'historique des paiements de vos demandes.',
  'tooltip.addPerson': 'Ajouter une nouvelle personne liée à votre compte.',
  'tooltip.urgent': 'Cela signifie que la demande est marquée comme urgente et doit être traitée dès que possible.',
  'tooltip.operationId': 'Le type de demande.',
  'tooltip.purposeOfVisit': 'Le motif de la visite pour cette demande.',
  'tooltip.amount': 'Le prix de cette demande.',
  'tooltip.paymentType': 'Le type de paiement pour cette demande de visa.',
  'tooltip.paymentReference': 'La référence du paiement pour cette demande de visa.',
  'tooltip.review': 'Examinez cette demande de visa en tant qu\'approuvée ou refusée et ajoutez un commentaire.',
  'tooltip.revision': 'Demandez au client de corriger la demande de visa.',
  'tooltip.approve': 'Approuvez cette demande de visa en tant que décision finale. Vous pouvez également ajouter un commentaire. Si le terme "blacklisté" est présent, la personne sera mise sur liste noire.',
  'tooltip.refuse': 'Refusez cette demande de visa en tant que décision finale. Vous pouvez également ajouter un commentaire.',
  'tooltip.qrSee': 'Voir le code QR de cette demande et imprimer le document qui y est lié.',
  'tooltip.internalEdit': 'Modifier la référence interne de cette demande de visa.',
  'tooltip.internalAdd': 'Ajouter une référence interne à cette demande.',
  'tooltip.printApplication': 'Imprimer la demande avec toutes les informations.',
  'tooltip.allReviews': 'Tous les avis sur cette demande de visa, avec la date et l\'utilisateur ayant effectué l\'examen.',
  'tooltip.version': 'La version actuelle de l\'application.',
  'tooltip.consumeProfile.IN': 'La photo capturée au point d\'entrée.',
  'tooltip.consumeNoProfile.IN': 'Aucune photo capturée au point d\'entrée.',
  'tooltip.consumeTime.IN': 'La date et l\'heure du point d\'entrée.',
  'tooltip.consumePlace.IN': 'Le lieu du point d\'entrée.',
  'tooltip.consumeProfile.OUT': 'La photo capturée au point de sortie.',
  'tooltip.consumeNoProfile.OUT': 'Aucune photo capturée au point de sortie.',
  'tooltip.consumeTime.OUT': 'La date et l\'heure du point de sortie.',
  'tooltip.consumePlace.OUT': 'Le lieu du point de sortie.',
  'tooltip.passportComparison': 'Informations scannées à partir du passeport. Cela vous permet de comparer les informations avec celles actuelles de la demande.',
  'tooltip.classicComparison': 'Informations actuelles de la demande. Cela vous permet de comparer les informations avec celles scannées à partir du passeport.',
  'tooltip.trackingApplicationReference': 'Référence de demande de ces demandes',
  'tooltip.allTrackingInfo': 'Toutes les informations sur cette demande',
  'tooltip.trackingPrint': 'Imprimer le document lié à cette demande',
  'tooltip.docFirstName': 'Entrez le prénom de la personne tel qu\'il apparaît sur le passeport.',
  'tooltip.docLastName': 'Entrez le nom de famille de la personne tel qu\'il apparaît sur le passeport.',
  'tooltip.docPassportNumber': 'Entrez le numéro de passeport de la personne.',
  'tooltip.docLinkType': 'Sélectionnez le type de relation que vous avez avec la personne.',
  'tooltip.docLinkTypeOther': 'Précisez le type de relation que vous avez avec la personne.',
  'tooltip.applicationReferenceRequest': 'La référence de demande de la demande. Elle est unique pour chaque demande, et elle est générée automatiquement.',
  'tooltip.portEntryRequest': 'Le point d\'entrée de la demande. C\'est le lieu où la personne entrera dans le pays.',
  'tooltip.otherName': 'Entrez le deuxième prénom du demandeur tel qu\'il apparaît sur le passeport.',
  'tooltip.spouseCheckbox': 'Cochez cette case si le demandeur a un conjoint et remplissez les informations ci-dessous.',
  'tooltip.hostName': 'Le nom de la personne/organisation qui accueillera le demandeur.',
  'tooltip.scanPassport': 'Scannez le passeport du demandeur pour trouver les demandes liées à ce passeport. Si aucune demande n\'est trouvée, vous pouvez en créer une nouvelle.',
  'tooltip.passportScanned': 'Les informations scannées à partir du passeport.',
  'tooltip.scannedCard': 'Demandes similaires trouvées avec les informations scannées.',
  'scan.error': 'Une erreur est survenue lors de la numérisation du document.',
  'tooltip.webcamProblems': 'Si la caméra ne fonctionne pas correctement, vous pouvez toujours valider l\'entrée ou la sortie de la demande sans photo.',
  'tooltip.checkOut': 'Valider la sortie de la personne du pays.',
  'tooltip.checkIn': 'Valider l\'entrée de la personne dans le pays.',
  'tooltip.consumeRefuse': 'Refuser l\'entrée ou la sortie de la personne.',
  'tooltip.finalRefuse': 'La décision finale de la demande. La personne ne pourra pas entrer dans le pays.',
  'tooltip.finalApprove': 'La décision finale de la demande. La personne pourra entrer ou sortir du pays.',
  'tooltip.finalPending': 'La décision finale de la demande. La personne ne pourra pas entrer dans le pays tant que la demande n\'est pas corrigée et approuvée.',
  'tooltip.finalRefuseBlacklist': 'La décision finale de la demande. La personne ne pourra pas entrer dans le pays et est mise sur liste noire.',
  'photo.entryCountry.IN': 'Photo à l\'enregistrement',
  'photo.entryCountry.OUT': 'Photo à la sortie',
  'err.noPassiveAuthenticationCSCA': 'Le document est valide, mais n\'a pas pu être vérifié auprès de son autorité émettrice.',
  'dashboard.noPreviousApplication': 'Aucune demande précédente trouvée.',
  'err.passport.expired': 'La validité du passeport a expiré.',
  'externalIndexedData': 'Plusieurs passeports trouvés',
  'client.extended.chargedBack': 'Cette demande de visa a fait l\'objet d\'un remboursement. La personne peut toujours procéder à la sortie, mais elle doit rembourser les frais d\'entrée en espèces uniquement.',
  'ask.chargedBack.confirm': 'Confirmez-vous que la personne a remboursé les frais d\'entrée ? Si vous confirmez, veuillez entrer la référence de paiement et la devise utilisée.',
  'error.payment.noReferenceChargedBack': 'Veuillez entrer une référence de paiement et la devise utilisée.',
  'client.extended.entryChargedBack': 'Cette demande de visa a fait l\'objet d\'un remboursement. La personne ne peut pas procéder à l\'enregistrement et doit créer une nouvelle entrée.',
  'tooltip.syncing': 'Le nombre de processus de demande actuellement en cours de synchronisation.',
  'adChoice': 'Connexion avec l\'annuaire actif',
  'form.username': 'Nom d\'utilisateur',
  'external.down': 'Un service dont dépend notre application ne fonctionne pas actuellement. Veuillez réessayer plus tard.',
  'global.connection.server': 'Service indisponible. Désolé pour la gêne occasionnée, veuillez réessayer plus tard.',
  'global.connection.timeout': 'La connexion a été interrompue. Veuillez vérifier votre connexion Internet et réessayer.',
  'global.connection.problem': 'Erreur lors du téléchargement de votre demande. Veuillez vérifier que vous n\'utilisez pas de VPN, de pare-feux, que votre connexion Internet est stable et réessayez.',
  'err.passport.issuedSoon': 'Le passeport a été délivré récemment (moins d\'un mois).',
  'global.reload': 'Recharger',
  'error.passportScan': 'CertBytes(b64) : <pre>{certBytes}</pre>',
  'glpi.err.noPassiveAuthenticationCSCA': 'Le hachage du certificat du passeport n\'a pas été trouvé dans la liste principale de l\'OACI, ce qui entraîne une erreur \'err.noPassiveAuthenticationCSCA\'.',
  'glpi.err.unverifiedDoc': 'Échec de la récupération des octets du certificat pour l\'authentification passive ; cela entraîne une erreur \'err.unverifiedDoc\'.',
  'glpi.err.noPassiveAuthentication': 'Échec de l\'authentification passive ; cela entraîne une erreur \'err.noPassiveAuthentication\'.',
  'glpi.err.noConnect': 'Échec de l\'établissement de la connexion avec la puce du passeport, ce qui entraîne une erreur \'err.noConnect\'.',
  'glpi.err.noBAC': 'BAC n\'a pas pu s\'établir avec les informations MRZ fournies, déclenchant une erreur \'err.noBAC\'.',
  'glpi.err.alteredDoc': 'Les hachages des groupes de données (DGS) sont incorrects pour une ou plusieurs entrées, ce qui entraîne une erreur \'err.alteredDoc\'.',
  'glpi.err.revokedDocSigner': 'Le numéro de série du certificat du signataire du document figure sur la liste de révocation des certificats (CRL), ce qui entraîne une erreur \'err.revokedDocSigner\'.',
  'watchlistCollapse': '<p>Listes de surveillance trouvées - <span class="watchlistCategories">{categories}</span></p>',
  'watchlistResponse.level': 'Niveau d\'alerte pour cette correspondance',
  'match.type': 'Type de correspondance',
  'match.hair': 'Cheveux',
  'match.eyes': 'Yeux',
  'match.height': 'Taille',
  'match.weight': 'Poids',
  'match.race': 'Race',
  'global.category': 'Catégorie',
  'watchlist.alertLevel': 'Niveau d\'alerte de la liste de surveillance',
  'watchlist.match': 'Correspondance {numberMatch} | <span class="watchlistCategories">{matchCategory}</span>',
  'Nationalities': 'Nationalité {index}',
  'global.score': 'Score',
  'watchlist.name': 'Nom de la liste de surveillance',
  'alias': 'Alias {index}',
  'document.number': 'Numéro du document {index}',
  'document.issuer': 'Émetteur du document {index}',
  'document.type': 'Type de document {index}',
  'dateOfBirth': 'Date de naissance {index}',
  'watchlist.marks': 'Marques',
  'watchlist.image.link': 'Lien vers l\'image trouvée {index}',
  'image.match': 'Image correspondante {index}',
  'tooltip.watchlist': 'Les informations de la liste de surveillance trouvées pour cette personne.',
  'watchList.category': 'Catégorie de la liste de surveillance',
  'scan.fingerprint.desc': 'Lorsque vous êtes prêt, cliquez sur le bouton ci-dessous pour commencer le processus de prise des empreintes digitales de la personne. La personne doit placer son index sur le scanner lorsque la lumière rouge de l\'appareil d\'empreintes digitales s\'allume, comme indiqué par l\'officier.',
  'scan.fingerprint.noResponse': 'Aucune réponse du scanner d\'empreintes digitales. La personne a-t-elle placé son doigt sur le scanner ? L\'appareil est-il correctement connecté ?',
  'scan.fingerprint': 'Empreinte digitale',
  'fingerprint.scan.start': 'Scanner l\'empreinte digitale',
  'scan.fingerprint.success': 'Les empreintes digitales ont été scannées avec succès. La qualité de l\'empreinte scannée est de {quality}/100. Vous pouvez réessayer le processus si la qualité n\'est pas suffisante.',
  'fingerprint.notAvailable': 'Il semble que le scanner d\'empreintes digitales ne soit pas disponible, ou que les pilotes ne soient pas installés. Vous pouvez toujours procéder à l\'enregistrement sans les empreintes digitales.',
  'skip': 'Ignorer',
  'global.checkOut.fingerprint': 'Sortir avec empreinte digitale',
  'global.checkIn.fingerprint': 'Entrer avec empreinte digitale',
  'tooltip.checkOut.fingerprint': 'Sortir la personne du pays avec l\'empreinte digitale.',
  'tooltip.checkIn.fingerprint': 'Entrer la personne dans le pays avec l\'empreinte digitale.',
  'paymentError.title': 'Problème avec votre commande',
  'DYN.paymentError.desc.fail': 'Malheureusement, le paiement a échoué. Veuillez réessayer.',
  'DYN.paymentError.desc.error': 'Malheureusement, le traitement du paiement a renvoyé une erreur. Veuillez nous contacter.',
  'DYN.paymentError.desc.later': 'Malheureusement, le traitement du paiement a été temporairement refusé. Veuillez réessayer.',
  'tooltip.applicationId': 'L\'ID de la demande.',
  'client.extended.missingResource': 'La ressource demandée est actuellement indisponible. Veuillez réessayer plus tard.',
  'skip.valid': 'Étapes examinées automatiquement ignorées',
  'extension.data': 'Données de l\'extension',
  'attestantAddress': 'Adresse de l\'attestant',
  'attestantEmail': 'E-mail de l\'attestant',
  'attestantID': 'ID de l\'attestant',
  'attestantName': 'Nom de l\'attestant',
  'attestantPhone': 'Téléphone de l\'attestant',
  'attestantRelation': 'Relation avec l\'attestant',
  'daysRequested': 'Nombre de jours demandés',
  'tooltip.visaApplicationReference': 'Aller à la demande de visa liée à cette demande d\'extension',
  'extend.visaReference': 'Demande liée à cette demande d\'extension',
  'data.copyOfEntry': 'Copie de l\'entrée',
  'data.departureTicket': 'Billet de départ',
  'data.attestantDocument': 'Document de l\'attestant',
  'data.affidavitCustody': 'Déclaration sous serment de garde',
  'reasonForExtention': 'Raison de l\'extension',
  'final.ZWEVISAEXTAB': 'Cette demande d\'extension doit être approuvée par l\'officier.',
  'zwevisaExtValid': 'Extension validée',
  'zwevisaExtValid.desc': 'Cette demande d\'extension a été validée par l\'officier.',
  'zwevisaExtC.review.state': 'En attente de vérification',
  'zwevisaExtC.review.desc': 'Cette demande d\'extension est en attente de vérification.',
  'zwevisaExtC.finalReview.desc': 'Cette demande d\'extension a été vérifiée et est actuellement en attente de vérification finale.',
  'zwevisaExtC.finalReview.state': 'En attente de vérification finale',
  'tooltip.tableLocalUsageUntil': 'La date d\'expiration de la demande fait référence à la date maximale de fin de séjour.',
  'tooltip.tableExtension': 'La date d\'expiration de la demande fait référence à l\'extension.',
  'ask.localUsageUntil.confirm': 'Vous pouvez ici modifier la date maximale de fin de séjour. Vous ne pouvez que réduire la date.',
  'localUsageUntil.ask': 'Modifier la date maximale de fin de séjour (optionnel)',
  'error.bad.localUsageUntil': 'La date maximale de fin de séjour doit être inférieure à la date d\'expiration actuelle et postérieure à aujourd\'hui.',
  'none': 'Aucun',
  'change.password.ad': 'Ayant un compte dans l\'annuaire actif, vous ne pouvez pas changer votre mot de passe ici. Pour plus d\'informations, veuillez contacter le support.',
  'noticePrint.title': 'Informations de l\'avis au visiteur imprimées pour le client',
  'reportingPost': 'Poste de rapport',
  'noticePrint.matTooltip': 'Informations de l\'avis au visiteur imprimées pour le client lors du processus d\'enregistrement',
  'notice.confirm': 'Êtes-vous sûr des informations figurant sur l\'avis ?',
  'camera.printNotice': 'Imprimer l\'avis',
  'global.refusePrint': 'Imprimer et soumettre',
  'global.nextPrint': 'Imprimer et continuer',
  'err.periodFrom.periodFromGreaterThanPeriodTo': 'La période de début doit être antérieure à la période de fin.',
  'payment.reject_reason': 'Raison du refus',
  'err.fileSize': 'La taille du fichier est trop grande. La taille maximale est de : {size}',
  'scan.birthCertificate': 'Télécharger l\'acte de naissance',
  'document.zafembpass': 'Passeport de l\'ambassade ZAF',
  'preenroll': 'Préinscription',
  'screen': 'Pré-vérification',
  'pass': 'Passeport',
  'zafembpass': 'Passeport de l\'ambassade ZAF',
  'document.pass': 'Passeport',
  'document.screen': 'Pré-vérification',
  'payment.ask.print': 'Le reçu a-t-il été imprimé ?',
  'global.no.retry': 'Non (réessayer)',
  'print.receipt': 'Imprimer le reçu',
  'tooltip.printReceipt': 'Imprimer le(s) reçu(s) de la demande',
  'ask.printReceipt': 'Voulez-vous imprimer le reçu daté du <b>{date}</b> ?',
  'error.printReceipt': 'Une erreur s\'est produite lors de l\'impression du reçu. Veuillez réessayer.',
  'ask.selectReceipt': 'Veuillez sélectionner le reçu que vous souhaitez imprimer.',
  'operation.OUT': 'Sortie',
  'operation.IN': 'Entrée',
  'operation.PAYMENT_FINALIZED': 'Paiement finalisé',
  'operation.PAYMENT_CREATED': 'Paiement créé',
  'operation.PAYMENT_USED_FORCE': 'Paiement utilisé (force)',
  'noChoice.selectedReceipt': 'Veuillez sélectionner un reçu à imprimer.',
  'select.receipt': 'Sélectionnez le reçu',
  'receiptFor.alt': 'Reçu pour',
  'paymentType': 'Type de paiement',
  'totalAmount.alt': 'Montant total',
  'totalAmount': 'Montant total',
  'date': 'Date',
  'client': 'Client',
  'agentID': 'ID de l\'agent',
  'desc': 'Description',
  'details': 'Détails',
  'client.extended.minUsageNotMet': 'La date de validité doit être au moins un jour après la date de début.',
  'payment.assigned.warning': 'Cette demande est actuellement en cours d\'utilisation active par un autre agent (Agent : {officerId}) il y a moins de 24 heures. Voulez-vous toujours ouvrir cette demande ?',
  'lock': 'Verrouiller',
  'tooltip.tableLockTitle': 'Utilisation active par l\'agent(s)',
  'tooltip.tableLock.me': 'Vous êtes actuellement l\'agent actif sur cette demande',
  'tooltip.tableLock.other': 'Cette demande est actuellement en cours d\'utilisation active par l\'agent {officer}',
  'client.extended.uuidNotPaid': 'Le paiement n\'a pas encore été validé. Veuillez valider le paiement avant de continuer.',
  'form.operationComments': 'Justifier l\'opération',
  'borderPass.emit': 'Laissez-passer frontalier émis',
  'tooltip.borderPass': 'Le laissez-passer frontalier est un document qui permet à une personne de traverser la frontière. Il est utilisé lorsque la personne ne possède pas de passeport.',
  'zweexit.title': 'Sortie sans visa',
  'borderPass.title': 'Laissez-passer frontalier',
  'print.borderPass': 'Imprimer le laissez-passer frontalier',
  'print.borderPass.ask': 'Le laissez-passer frontalier a-t-il été imprimé ?',
  'err.issueDate.afterExpiryDate': 'La date de délivrance doit être antérieure à la date d\'expiration.',
  'err.BirthDay.afterExpiryDate': 'La date de naissance doit être antérieure à la date d\'expiration.',
  'err.BirthDay.afterIssueDate': 'La date de naissance doit être antérieure à la date de délivrance.',
  'apiPnrCollapse': 'PNR trouvé',
  'apipnrResponse.match': 'Correspondance {numberMatch}',
  'match.name': 'Nom',
  'match.score.name': 'Score du nom',
  'match.flightCarrier': 'Compagnie aérienne',
  'match.flightNumber': 'Numéro de vol',
  'match.documentType': 'Type de document',
  'match.documentNumber': 'Numéro de document',
  'match.documentIssuer': 'Délivreur du document',
  'match.timeType': 'Type d\'événement',
  'match.timeDate': 'Date de l\'événement',
  'match.timeScope': 'Portée de l\'événement',
  'match.nationality': 'Nationalité',
  'match.gender': 'Genre',
  'match.uuid': 'UUID',
  'match.travelerUUID': 'UUID du voyageur',
  'tooltip.apiPnr': 'Les informations PNR trouvées pour cette personne.',
  'match.documentIssued': 'Date de délivrance du document',
  'match.placeIssued': 'Lieu de délivrance du document',
  'match.documentExpiration': 'Date d\'expiration du document',
  'match.documentScore': 'Score du document',
  'match.timeScore': 'Score de l\'événement',
  'match.flightOriginDomestic': 'Origine domestique du vol',
  'match.flightOriginIcao': 'OACI de l\'origine du vol',
  'match.flightOriginLat': 'Latitude de l\'origine du vol',
  'match.flightOriginLng': 'Longitude de l\'origine du vol',
  'match.flightOriginIata': 'IATA de l\'origine du vol',
  'match.flightOriginCity': 'Ville de l\'origine du vol',
  'match.flightOriginState': 'État de l\'origine du vol',
  'match.flightOriginCountry': 'Pays de l\'origine du vol',
  'match.flightOriginContinent': 'Continent de l\'origine du vol',
  'match.flightOriginName': 'Nom de l\'origine du vol',
  'match.flightOriginTimezone': 'Fuseau horaire de l\'origine du vol',
  'match.flightDestinationDomestic': 'Destination domestique du vol',
  'match.flightDestinationIcao': 'OACI de la destination du vol',
  'match.flightDestinationLat': 'Latitude de la destination du vol',
  'match.flightDestinationLng': 'Longitude de la destination du vol',
  'match.flightDestinationIata': 'IATA de la destination du vol',
  'match.flightDestinationCity': 'Ville de la destination du vol',
  'match.flightDestinationState': 'État de la destination du vol',
  'match.flightDestinationCountry': 'Pays de la destination du vol',
  'match.flightDestinationContinent': 'Continent de la destination du vol',
  'match.flightDestinationName': 'Nom de la destination du vol',
  'match.flightDestinationTimezone': 'Fuseau horaire de la destination du vol',
  'match.localDepartureDate': 'Date de départ locale',
  'match.localDepartureTime': 'Heure de départ locale',
  'match.localDepartureTotalMinutes': 'Minutes totales de départ local',
  'match.localDepartureDay': 'Jour de départ local',
  'match.localDepartureZone': 'Zone de départ locale',
  'match.airportDepartureDate': 'Date de départ de l\'aéroport',
  'match.airportDepartureTime': 'Heure de départ de l\'aéroport',
  'match.airportDepartureTotalMinutes': 'Minutes totales de départ de l\'aéroport',
  'match.airportDepartureDay': 'Jour de départ de l\'aéroport',
  'match.airportDepartureZone': 'Zone de départ de l\'aéroport',
  'match.utcDepartureDate': 'Date de départ UTC',
  'match.utcDepartureTime': 'Heure de départ UTC',
  'match.utcDepartureTotalMinutes': 'Minutes totales de départ UTC',
  'match.utcDepartureDay': 'Jour de départ UTC',
  'match.utcDepartureZone': 'Zone de départ UTC',
  'match.originalDeparture': 'Départ d\'origine',
  'match.flightDepartureUtcstr': 'Départ de vol UTC',
  'match.localArrivalDate': 'Date d\'arrivée locale',
  'match.localArrivalTime': 'Heure d\'arrivée locale',
  'match.localArrivalTotalMinutes': 'Minutes totales d\'arrivée locale',
  'match.localArrivalDay': 'Jour d\'arrivée locale',
  'match.localArrivalZone': 'Zone d\'arrivée locale',
  'match.airportArrivalDate': 'Date d\'arrivée de l\'aéroport',
  'match.airportArrivalTime': 'Heure d\'arrivée de l\'aéroport',
  'match.airportArrivalTotalMinutes': 'Minutes totales d\'arrivée de l\'aéroport',
  'match.airportArrivalDay': 'Jour d\'arrivée de l\'aéroport',
  'match.airportArrivalZone': 'Zone d\'arrivée de l\'aéroport',
  'match.utcArrivalDate': 'Date d\'arrivée UTC',
  'match.utcArrivalTime': 'Heure d\'arrivée UTC',
  'match.utcArrivalTotalMinutes': 'Minutes totales d\'arrivée UTC',
  'match.utcArrivalDay': 'Jour d\'arrivée UTC',
  'match.utcArrivalZone': 'Zone d\'arrivée UTC',
  'match.originalArrival': 'Arrivée d\'origine',
  'match.flightArrivalUtcstr': 'Arrivée de vol UTC',
  'match.flightBound': 'Vol lié',
  'ask.notice': 'Imprimer un avis au visiteur ou un avis de restriction provisoire',
  'tooltip.checkIn.notice': 'Enregistrer l\'entrée de la personne dans le pays et imprimer l\'avis au visiteur ou un avis de restriction provisoire.',
  'global.checkIn.notice': 'Enregistrement avec un avis',
  'event.downgrade': 'Cette demande a été rétrogradée de <b>{previousPayment}</b> à <b>{newPayment}</b> le {date} par l\'utilisateur <b>{userId}</b>.',
  'form.numberPeople': 'Nombre de personnes voyageant avec le demandeur',
  'feedbackForm': 'Formulaire de retour',
  'form.totalSpend': 'Dépense totale durant le séjour',
  'countryPermanentResidence': 'Pays de résidence permanente',
  'form.feedbackComments': 'Commentaires supplémentaires',
  'feedback.submit': 'Soumettre le retour',
  'feedback.submitted': 'Le retour a été soumis avec succès.',
  'smartTable.placeId': 'ID Place',
  'smartTable.timeslotPlaceId': 'Lieu du créneau',
  'smartTable.id': 'ID',
  'smartTable.userId': 'ID utilisateur',
  'smartTable.name': 'Nom',
  'smartTable.role': 'Rôle',
  'smartTable.email': 'Email',
  'smartTable.creationDate': 'Date de création',
  'smartTable.applicationId': 'ID de la demande',
  'smartTable.lock': 'Verrouillage',
  'smartTable.internalReference': 'Référence HQ',
  'smartTable.nationality': 'Nationalité',
  'smartTable.batchId': 'Référence de la demande',
  'smartTable.firstName': 'Prénom',
  'smartTable.lastName': 'Nom de famille',
  'smartTable.fullName': 'Nom complet',
  'smartTable.passportNumber': 'Numéro de passeport',
  'smartTable.isUrgent': 'Urgent',
  'smartTable.paymentStatus': 'Statut de paiement',
  'smartTable.price': 'Prix',
  'smartTable.usageAfter': 'Valide à partir de',
  'smartTable.usageUntil': 'Valide jusqu\'à',
  'smartTable.operationId': 'Type de document',
  'smartTable.filter.isUrgent': 'Urgent ',
  'smartTable.filter.overstay': 'Dépassement de séjour',
  'smartTable.filter.applicationType': 'Type de demande',
  'smartTable.filter.paymentStatus': 'Statut de la demande',
  'smartTable.filter.paymentExtStatus': 'Statut de l\'extension',
  'smartTable.filter.createAtStart': 'Date (début)',
  'smartTable.filter.createAtEnd': 'Date (fin)',
  'smartTable.filter.sinceDays': 'Depuis',
  'smartTable.filter.timeslotStart': 'Créneau (début)',
  'smartTable.filter.timeslotEnd': 'Créneau (fin)',
  'time.day': '{value} jour',
  'time.days': '{value} jours',
  'time.week': '{value} semaine',
  'time.weeks': '{value} semaines',
  'time.month': '{value} mois',
  'time.months': '{value} mois',
  'time.year': '{value} année',
  'residencePermit.warning': 'Numéro de titre de séjour <b>{permitNumber}</b> invalide ou introuvable dans la base de données.<br><br>Veuillez vérifier manuellement ce numéro sur le titre de séjour physique du voyageur avant d\'autoriser l\'entrée.',
  'statusLabel.toConfirm': '(à confirmer)',
  'form.lang.IT': 'Italiano',
  'form.lang.JA': '日本語',
  'form.birthCity': 'Ville de naissance',
  'form.eyeColor': 'Couleur des yeux',
  'form.hairColor': 'Couleur des cheveux',
  'form.height': 'Taille',
  'form.occupation': 'Occupation',
  'form.fatherFirstName': 'Prénom du père',
  'form.fatherLastName': 'Nom du père',
  'form.motherFirstName': 'Prénom de la mère',
  'form.motherLastName': 'Nom de la mère',
  'form.physical.description': 'Description physique',
  'refusalReason.review.desc.DYN.visa': 'Veuillez fournir une brève description de la révision comme <b>NON RECOMMANDÉE</b>. Cette description sera envoyée au prochain réviseur.',
  'approveReason.review.desc.DYN.visa': 'Veuillez fournir une brève description de la révision comme <b>RECOMMANDÉE</b>. Cette description sera envoyée au prochain réviseur.',
  'documents.no.documents': 'Aucun document n’a été trouvé pour cette application',
  'OtherPurpose': 'Autre raison',
  'RegistrationType': 'Votre type',
  'ManagerJobTitle': 'Titre du poste du dirigeant',
  'BusinessRegistrationNumber': 'Numéro d’immatriculation de l’entreprise',
  'CompanyName': 'Nom de l’entreprise',
  'global.naturalPerson': 'Personne physique',
  'global.legalEntity': 'Personne morale',
  'DYN.GENERAL_MANAGER': 'Directeur général',
  'DYN.PRESIDENT_CEO': 'Président-directeur général',
  'DYN.HR_DIRECTOR': 'Directeur des ressources humaines',
  'DYN.CONSULAR_CARD': 'Carte consulaire',
  'DYN.NATIONAL_IDENTITY_CARD': 'Carte nationale d’identité',
  'DYN.PASSPORT': 'Passeport',
  'DYN.RESIDENT_CARD': 'Carte de résident',
  'IdentificationDocument': 'Document d\'identification',
  'applicant_information': 'Informations du demandeur',
  'applier_information': 'Informations du demandeur',
  'DYN.BROTHER': 'Frère',
  'DYN.SISTER': 'Sœur',
  'DYN.MOTHER': 'Mère',
  'DYN.FATHER': 'Père',
  'DYN.GRANDFATHER': 'Grand-père',
  'DYN.GRANDMOTHER': 'Grand-mère',
  'DYN.HUSBAND': 'Mari',
  'DYN.MARRY': 'Époux/Épouse',
  'DYN.CHILD': 'Enfant',
  'DYN.FRIEND': 'Ami(e)',
  'DYN.COUSIN': 'Cousin(e)',
  'DYN.FULL_ADOPTION': 'Adoption plénière',
  'DYN.SIMPLE_ADOPTION': 'Adoption simple',
  'DYN.EMPLOYEE': 'Employé(e)',
  'DYN.MYSELF': 'Moi-même',
  'BROTHER': 'Frère',
  'SISTER': 'Sœur',
  'MOTHER': 'Mère',
  'FATHER': 'Père',
  'GRANDFATHER': 'Grand-père',
  'GRANDMOTHER': 'Grand-mère',
  'HUSBAND': 'Mari',
  'MARRY': 'Époux/Épouse',
  'CHILD': 'Enfant',
  'FRIEND': 'Ami(e)',
  'COUSIN': 'Cousin(e)',
  'FULL_ADOPTION': 'Adoption plénière',
  'SIMPLE_ADOPTION': 'Adoption simple',
  'EMPLOYEE': 'Employé(e)',
  'MYSELF': 'Moi-même',
  'OTHER': 'Autre',
  'DYN.MODIFICATION': 'Modification',
  'DYN.DUPLICATE': 'Duplicata',
  'DYN.WORKER': 'Travailleur',
  'DYN.RELIGIOUS': 'Religieux',
  'DYN.SPOUSE_TAKEN_CARE_OF': 'Conjoint pris en charge',
  'DYN.MERCHANTS': 'Commerçants',
  'DYN.CORPORATION_WORKERS_VOLUNTEERS_FRENCH': 'Travailleurs/Bénévoles français d\'entreprise',
  'DYN.FRENCH_NATIONAL': 'Ressortissant français',
  'DYN.STUDENTS': 'Étudiants',
  'DYN.CRAFTSMAN': 'Artisan',
  'DYN.MINOR_UNDER_16': 'Mineur de moins de 16 ans',
  'DYN.WITHDRAWN': 'Retiré',
  'DYN.MALE': 'Masculin',
  'DYN.FEMALE': 'Féminin',
  'NationalId': 'Identité nationale',
  'RequestReason': 'Motif de la demande',
  'DYN.LEGAL': 'Légal',
  'DYN.NATURAL': 'Naturel',
  'WorkContract': 'Contrat de travail',
  'GuardianIdCard': 'Carte d\'identité du tuteur',
  'guardian.data': 'Données du tuteur',
  'guardianManager.data': 'Données du tuteur manager',
  'DYN.NEW_REQUEST': 'Nouvelle demande',
  'DYN.RENEWAL': 'Renouvellement',
  'DYN.LOST': 'Perdu',
  'IdNumber': 'Numéro d’identification',
  'BirthEntryNumber': 'Numéro d’acte de naissance',
  'NameChanged': 'Votre nom a-t-il été changé ?',
  'OriginalName': 'Nom d’origine',
  'NameChangedTo': 'Nom modifié en',
  'NameChangeDate': 'Date du changement',
  'personal_details_1': 'Détails personnels - 1',
  'personal_details_2': 'Détails personnels - 2',
  'EyeColor': 'Couleur des yeux',
  'HairColor': 'Couleur des cheveux',
  'VisibleMark': 'Marques visibles ou particularités',
  'MarriageDate': 'Date du mariage',
  'MarriagePlace': 'Lieu du mariage',
  'SpouseCitizenship': 'Citoyenneté du conjoint',
  'MarriageDivorceOrderNumber': 'Numéro de l’acte de mariage ou de divorce',
  'personal_details_3': 'Détails personnels - 3',
  'FullName': 'Nom complet',
  'Relationship': 'Lien de parenté',
  'next_of_kin': 'Proche parent',
  'declaration': 'Déclaration',
  'global.renewal': 'Renouvellement',
  'global.newRequest': 'Nouvelle demande',
  'global.lost': 'Perdu',
  'DYN.BLOND': 'Blond',
  'DYN.CHESTNUT': 'Châtain',
  'DYN.BROWN': 'Brun',
  'DYN.BLACK': 'Noir',
  'DYN.RED': 'Roux',
  'DYN.GRAY_WHITE': 'Gris / Blanc',
  'DYN.OTHER': 'Autre',
  'DYN.BLUE': 'Bleu',
  'DYN.GRAY': 'Gris',
  'DYN.GREEN': 'Vert',
  'DYN.HAZEL': 'Noisette',
  'DYN.YES': 'Oui',
  'DYN.NO': 'Non',
  'DYN.NA': 'Non applicable',
  'DYN.SINGLE': 'Célibataire',
  'DYN.MARRIED': 'Marié(e)',
  'DYN.SEPARATED': 'Séparé(e)',
  'DYN.DIVORCED': 'Divorcé(e)',
  'DYN.WIDOWED': 'Veuf / Veuve',
  'DYN.MARRIED_ACCORDING_TO_CUSTOM': 'Marié(e) selon les coutumes',
  'DYN.RELIGIOUSLY_MARRIED': 'Marié(e) selon les rites religieux',
  'MarriageCountry': 'Pays du mariage',
  'NationalityCertificate': 'Certificat de nationalité',
  'MarriageCertificate': 'Certificat de mariage',
  'CitizenshipCertificate': 'Certificat de citoyenneté',
  'OldPassportOrEmergencyTravelDocument': 'Ancien passeport ou document de voyage d’urgence',
  'global.N/A': 'N/A',
  'DYN.YES-VALID': 'Oui - Valide',
  'DYN.YES-EXPIRED': 'Oui - Expiré',
  'DYN.YES-FULL': 'Oui - Complet',
  'DYN.YES-LOST': 'Oui - Perdu',
  'Height': 'Taille (cm)',
  'IdNumber_desc': '',
  'err.pattern.^[0-9]+$': 'Le champ "{fieldName}" n\'accepte que des valeurs numériques.',
  'err.pattern.^(?:[3-9][0-9]|[12][0-9][0-9]|2[0-4][0-9]|250)$': 'La valeur "{fieldName}" est hors de la plage acceptable!',
  'smartTable.registrationPortId': 'Lieu',
  'magicLinkLogin.title': 'Connexion par Lien Magique',
  'magicLinkLogin.description': 'Entrez votre email ou numéro de téléphone pour recevoir un lien de connexion.',
  'magicLinkLogin.descriptionEmailOnly': 'Entrez votre adresse email pour recevoir un lien de connexion.',
  'magicLinkLogin.descriptionSmsOnly': 'Entrez votre numéro de téléphone pour recevoir un lien de connexion par SMS.',
  'magicLinkLogin.email': 'Email',
  'magicLinkLogin.phone': 'Téléphone',
  'magicLinkLogin.country': 'Pays',
  'magicLinkLogin.selectCountry': 'Sélectionnez un pays',
  'magicLinkLogin.sendLink': 'Envoyer le Lien',
  'magicLinkLogin.linkSent': 'Lien magique envoyé !',
  'magicLinkLogin.checkDevice': 'Vérifiez votre email ou téléphone pour le lien de connexion.',
  'magicLinkLogin.checkEmail': 'Vérifiez votre email pour le lien de connexion.',
  'magicLinkLogin.checkSms': 'Vérifiez votre téléphone pour le lien de connexion.',
  'magicLinkLogin.sendAnother': 'Envoyer un Autre Lien',
  'magicLinkLogin.backToLogin': 'Retour au formulaire de connexion',
  'magicLinkLogin.backToSignIn': 'Retour à la connexion',
  'err.pattern.^0[0-9]{9}$': 'Numéro de téléphone invalide',
  'err.pattern.^[0-9A-Za-z]{1,50}$': 'Le champ "{fieldName}" doit contenir au maximum 50 caractères.',
  'mother_names_desc': '',
  'father_names_desc': '',
  'form.accountName': 'Nom du compte',
  'form.seniority.ownPlace': 'Lieu personnel uniquement',
  'form.seniority.allPlaces': 'Tous les lieux',
  'ManagerJobTitleOther': 'Veuillez préciser le titre du poste',
  'AttestantRelationOther': 'Veuillez préciser la relation',
  'RequestReasonOther': 'Veuillez préciser la raison',
  'RequestReasonOtherTitle': 'Autre raison',
  'Status': 'Statut',
  'StatusOther': 'Veuillez préciser le statut',
  'CRNNIExpiryDate': 'Date d\'expiration CR/NNI',
  'CRNNI': 'Numéro CR/NNI',
  'nav.searchFromDocument': 'Recherche depuis le document',
  'tooltip.nextApplication': 'Charger la prochaine demande nécessitant un traitement',
  'nextApplication.button': 'Traiter la Demande Suivante',
  'error.insufficientPermissions': 'Permissions insuffisantes pour accéder à cette fonctionnalité',
  'nextApplication.noMore': 'Aucune autre demande à traiter',
  'nextApplication.error': 'Erreur lors du chargement de la demande suivante',
  'document.Preview': 'Aperçu du document',
  'DYN.ABIDJAN': 'ABIDJAN',
  'DYN.BOUAKE': 'BOUAKE',
  'DYN.DALOA': 'DALOA',
  'DYN.YAMOUSSOUKRO': 'YAMOUSSOUKRO',
  'DYN.SAN_PEDRO': 'SAN_PEDRO',
  'DYN.KORHOGO': 'KORHOGO',
  'DYN.GAGNOA': 'GAGNOA',
  'DYN.MAN': 'MAN',
  'faq': 'FAQ',
  'tooltip.faq': 'Accéder aux questions fréquemment posées pour obtenir de l\'aide',
  'traveller.history.title': 'Historique du voyageur',
  'traveller.history.loading': 'Chargement de l\'historique…',
  'traveller.history.entry_exit': 'Entrée / Sortie',
  'traveller.history.compliance': 'Conformité',
  'traveller.history.view_more': 'Voir plus',
  'traveller.history.collapse': 'Réduire',
  'traveller.history.no_records': 'Aucun enregistrement trouvé',
  'traveller.history.records': 'enregistrements',
  'traveller.history.user': 'Utilisateur',
  'traveller.history.reason': 'Raison',
  'traveller.history.additional_info': 'Informations complémentaires',
  'traveller.history.event.ENTERED_COUNTRY': 'Entrée dans le pays',
  'traveller.history.event.EXITED_COUNTRY': 'Sortie du pays',
  'traveller.history.event.DEPORTATION_CREATED': 'Expulsion créée',
  'traveller.history.event.DEPORTATION_EDITED': 'Expulsion modifiée',
  'traveller.history.event.DEPORTATION_APPROVED_BY_SUPERVISOR': 'Expulsion approuvée par le superviseur',
  'traveller.history.event.DEPORTATION_APPROVED_BY_DIR_OPS': 'Expulsion approuvée par le Dir. Ops',
  'traveller.history.event.SUCCESSFULLY_DEPORTED': 'Expulsion réussie',
  'traveller.history.event.DEPORTATION_DECLINED': 'Expulsion refusée',
  'traveller.history.event.ADDED_TO_WATCHLIST': 'Ajouté à la liste de surveillance',
  'traveller.history.event.REMOVED_FROM_WATCHLIST': 'Retiré de la liste de surveillance',
  'traveller.history.event.PROSECUTION_CREATED': 'Poursuite créée',
  'traveller.history.event.ADDED_BIOMETRIC': 'Biométrie ajoutée',
  'traveller.history.event.INTERVIEW_CREATED': 'Entretien créé',
  'traveller.history.event.INTERVIEW_EDITED': 'Entretien modifié',
  'traveller.history.event.REFUGEE_RECORD_CREATED': 'Dossier de réfugié créé',
  'traveller.history.event.REFUGEE_RECORD_EDITED': 'Dossier de réfugié modifié',
  'traveller.history.visa': 'Visa',
  'traveller.history.event.VALIDATED': 'Validé',
  'traveller.history.event.REFUSED': 'Refusé',
  'traveller.history.permits': 'Permis',
  'traveller.history.permit.ORDINARY_RESIDENCE_PERMIT': 'Permis de séjour ordinaire',
  'traveller.history.permit.SPOUSE_RESIDENCE_PERMIT': 'Permis de séjour conjoint',
  'traveller.history.permit.INVESTOR_RESIDENCE_PERMIT': 'Permis de séjour investisseur',
  'traveller.history.permit.STUDENTS_PERMIT': 'Permis étudiant',
  'traveller.history.permit.SCHOLARS_PERMIT': 'Permis scolaire',
  'traveller.history.permit.TEMPORARY_EMPLOYMENT_PERMIT': 'Permis de travail temporaire',
  'traveller.history.permit.AUTHORITY_TO_WORK': 'Autorisation de travail',
  'traveller.history.permit.RESUMPTION': 'Reprise',
  'traveller.history.permit.DUAL_CITIZENSHIP': 'Double nationalité',
  'traveller.history.permit.REINSTATEMENT': 'Réintégration',
  'traveller.history.permit.applicationType': 'Type de demande',
  'traveller.history.permit.appType.INITIAL': 'Initiale',
  'traveller.history.permit.appType.EXTENSION': 'Prolongation',
  'traveller.history.permit.appType.PERMANENT': 'Permanente',
  'traveller.history.permit.status.REQUESTED': 'Demandé',
  'traveller.history.permit.status.APPROVED': 'Approuvé',
  'traveller.history.permit.status.REJECTED': 'Rejeté',
  'traveller.history.permit.issueDate': 'Date d\'émission',
  'traveller.history.permit.expiryDate': 'Date d\'expiration',
  'smartTable.isDelayed': 'En retard',
  'print.withdrawal.place': 'Lieu de retrait',
  'print.withdrawal.date': 'Date de retrait',
  'showcase.heroTitle': 'Rapide, sécurisé & <em>numérique</em><br/>eVisa en toute simplicité.',
  'showcase.heroSubtitle': 'Faites votre demande, vérifiez et voyagez en quelques minutes. {name} associe l\'identité biométrique à un moteur de décision gouvernemental — pour que votre approbation arrive avant vous.',
  'showcase.heroSubtitle.evisa': 'Faites votre demande, vérifiez et voyagez en quelques minutes. {name} associe l\'identité biométrique à un moteur de décision gouvernemental — pour que votre approbation arrive avant vous.',
  'showcase.heroSubtitle.passport_idCard_residencePermit': 'Remplissez votre demande de passeport, de carte d\'identité nationale ou de permis de résidence en ligne. {name} traite et suit chaque demande en temps réel, de la soumission à la livraison.',
  'showcase.heroSubtitle.passport_idCard': 'Faites votre demande de passeport ou de carte d\'identité nationale en ligne. {name} traite et suit chaque demande en temps réel.',
  'showcase.heroSubtitle.passport': 'Faites votre demande de passeport en ligne. {name} traite et suit chaque demande en temps réel, de la soumission à la livraison.',
  'showcase.heroSubtitle.idCard': 'Faites votre demande de carte d\'identité nationale en ligne. {name} traite et suit chaque demande en temps réel.',
  'showcase.heroSubtitle.residencePermit': 'Faites votre demande de permis de résidence en ligne. {name} traite et suit chaque demande en temps réel.',
  'showcase.heroSubtitle.passport_residencePermit': 'Faites votre demande de passeport ou de permis de résidence en ligne. {name} traite et suit chaque demande en temps réel.',
  'showcase.heroSubtitle.idCard_residencePermit': 'Faites votre demande de carte d\'identité ou de permis de résidence en ligne. {name} traite et suit chaque demande en temps réel.',
  'showcase.heroCta1': 'Demander un eVisa',
  'showcase.heroCta2': 'Suivre ma demande',
  'showcase.flowTitleMain': 'Quatre étapes.<br/><em>Zéro file d\'attente.</em>',
  'showcase.flowTitleSub': 'Une demande qui vous accompagne partout.',
  'showcase.flowSubtitle': '{name} orchestre les quatre étapes de votre demande en un mouvement fluide, le système gère les formalités pendant que vous faites vos bagages.',
  'showcase.ctaTitle': 'Commencez votre voyage<br/><em>numériquement.</em>',
  'showcase.ctaSubtitle': 'Une demande. Un eVisa dans votre poche et une décision qui arrive avant vous.',
  'showcase.step1.label': 'Créer la demande',
  'showcase.step1.paneTitle': 'Remplissez vos informations',
  'showcase.step1.paneDesc': 'Destination, dates de voyage, motif de visite et port d\'entrée…',
  'showcase.step2.label': 'Téléverser les documents',
  'showcase.step2.paneTitle': 'Téléversez votre passeport',
  'showcase.step2.paneDesc': 'Numérisation du passeport, lecture MRZ, extraction instantanée des données…',
  'showcase.step3.label': 'Vérification biométrique',
  'showcase.step3.paneTitle': 'Vivacité & correspondance faciale',
  'showcase.step3.paneDesc': 'Détection de vivacité, correspondance faciale et contrôle des sanctions…',
  'showcase.step4.label': 'Approbation instantanée',
  'showcase.step4.paneTitle': 'Approuvé & prêt à la frontière',
  'showcase.step4.paneDesc': 'Votre eVisa est signé, certifié et synchronisé avec votre portefeuille…',
  'showcase.stat1.value': 'Chiffré',
  'showcase.stat1.label': 'de bout en bout',
  'showcase.stat2.value': 'Certifié',
  'showcase.stat2.label': 'plateforme sécurisée',
  'showcase.portalType': 'Portail eVisa',
  'showcase.tl.step1': 'Identité',
  'showcase.tl.step3': 'Décision',
  'showcase.tl.step4': 'Voyage',
  'showcase.tl.step2': 'Documents',
  'showcase.evisa.ministry': 'MINISTÈRE DES AFFAIRES ÉTRANGÈRES',
  'showcase.marquee.issuedBy': 'Émis par des autorités souveraines',
  'showcase.marquee.biometric': 'Biométrique',
  'showcase.marquee.secured': 'Sécurisé',
  'showcase.marquee.borderReady': 'Prêt à la frontière en minutes',
  'showcase.marquee.encrypted': 'Chiffré de bout en bout',
  'showcase.marquee.eSeal': 'Sceau électronique qualifié',
  'showcase.marquee.realtime': 'Suivi en temps réel',
  'showcase.annot.mrz': 'MRZ vérifié',
  'showcase.annot.biometric': 'Biométrique',
  'showcase.annot.issued': 'Émis',
  'showcase.annot.secured': 'Sécurisé',
  'showcase.howItWorks': 'Comment ça marche',
  'showcase.signIn': 'Se connecter à mon compte',
  'showcase.scroll': 'Défiler',
  'showcase.permit.badge': 'RÉSIDENT',
  'showcase.permit.title': 'PERMIS',
  'showcase.permit.name': 'Carte de séjour',
  'finger.thumb': 'Pouce',
  'finger.index': 'Index',
  'finger.middle': 'Majeur',
  'finger.ring': 'Annulaire',
  'finger.little': 'Auriculaire',
  'finger.missing': 'Manquant',
  'hand.left': 'Main gauche',
  'hand.right': 'Main droite',
  'fingerprints': 'Empreintes digitales',
  'finger.thumbs': 'Pouces',
  'fingers.missing': 'Doigts manquants',
  'signature': 'Signature',
  'global.checkOut.notice': 'Sortie avec avis',
  'trips.helper': 'Cliquez pour afficher/télécharger le code QR',
  'cancelled': 'Annulé',
  'global.goLatest': 'Ouvrir la dernière demande visitée',
  'paidOnline': '(Payé en ligne)',
  'payAttention': 'Je ferai attention',
  'print.date': 'Date d\'impression',
  'transit.consume': 'Transit',
  'watchlist.null': '<b>Le système {system} n\'a pas pu être vérifié</b>'
};
